// AUTO-GENERATED by scripts/gen-services-head.ts — do not edit by hand.
// Light service metadata for route head()/loader. Full catalog: @/data/services
import type { ServiceId } from "@/data/services";

export type ServiceHeadMeta = {
  id: ServiceId;
  slug: string;
  nameTh: string;
  nameEn: string;
  shortTh: string;
  taglineTh: string;
  taglineEn: string;
  metaTitle: string;
  metaDesc: string;
  keywords: string[];
  priceFrom: number;
  priceTo?: number;
  turnaround: string;
  documentsTh?: string[];
  coverage?: string;
  languagesCount?: number;
  relatedServiceIds: ServiceId[];
  faqCount: number;
};

export const SERVICE_HEAD = {
 "translation": {
  "id": "translation",
  "slug": "translation",
  "nameTh": "บริการแปลและรับรองเอกสารทุกภาษาทั่วโลก",
  "nameEn": "Certified Translation Services (All Languages)",
  "shortTh": "แปลและรับรอง 50+ ภาษา · ใช้ยื่นวีซ่า/ราชการ/สถานทูตได้จริง",
  "taglineTh": "นักแปลผู้เชี่ยวชาญ 50+ ภาษา รับรองคำแปลโดยบริษัทที่ขึ้นทะเบียนกรมการกงสุล นำไปใช้ยื่นวีซ่า · จดทะเบียนสมรส · ศึกษาต่อ · ทำงานต่างประเทศได้ทันที",
  "taglineEn": "Certified document translation in 50+ languages, accepted by Thai MFA, embassies worldwide, immigration offices, courts, and universities.",
  "metaTitle": "บริการแปลและรับรองเอกสาร 50+ ภาษา ทั่วประเทศ | NYC Legal",
  "metaDesc": "บริการแปลและรับรองเอกสารทุกภาษา ทุกชนิดเอกสาร — สูติบัตร ทะเบียนบ้าน ใบรับรองโสด ใบจดทะเบียนสมรส ใบหย่า transcript ใช้ยื่นวีซ่า/สถานทูต/MFA ได้ทันที ตอบใน 15 นาที โทร 083-249-4999",
  "keywords": [
   "รับแปลเอกสาร",
   "แปลรับรองกงสุล",
   "แปลภาษาอังกฤษ",
   "แปลภาษาจีน",
   "แปลภาษาญี่ปุ่น",
   "แปลเอกสารใช้ยื่นวีซ่า",
   "Certified Translation Thailand",
   "Sworn Translator Bangkok"
  ],
  "priceFrom": 500,
  "priceTo": 2500,
  "turnaround": "เร่งด่วน 4 ชม. · มาตรฐาน 1–3 วัน",
  "coverage": "ทั่วประเทศไทย + ออนไลน์ทั่วโลก",
  "languagesCount": 50,
  "relatedServiceIds": [
   "notary-public",
   "mfa-legalization",
   "embassy-legalization",
   "naati"
  ],
  "faqCount": 14
 },
 "notary-public": {
  "id": "notary-public",
  "slug": "notary-public",
  "nameTh": "บริการรับรองเอกสาร Notary Public โดยทนายความรับรองลายมือชื่อ",
  "nameEn": "Notary Public / Notarial Services Attorney",
  "shortTh": "ทนาย Notary Public 6 ท่าน · รับรองได้ทันที · ใช้ในและต่างประเทศ",
  "taglineTh": "ทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร (Notarial Services Attorney) ขึ้นทะเบียนสภาทนายความแห่งประเทศไทย — 6 ทนายประจำ ดำเนินการได้ทันที พร้อม Apostille / รับรองกงสุล / สถานทูตครบวงจร",
  "taglineEn": "Notarial Services Attorney certified by the Lawyers Council of Thailand — 6 in-house notaries, same-day signature certification, full embassy/MFA legalization workflow.",
  "metaTitle": "Notary Public รับรองเอกสารโดยทนาย ทันที | NYC Legal Bangkok",
  "metaDesc": "บริการ Notary Public โดยทนายความรับรองลายมือชื่อ ขึ้นทะเบียนสภาทนายความฯ · 6 ทนายประจำ · รับรอง Affidavit, POA — ส่งภาพเอกสารมาเช็กให้ก่อน ฟรี ไม่คิดค่าปรึกษา083-249-4999",
  "keywords": [
   "Notary Public Thailand",
   "Notarial Services Attorney",
   "รับรองเอกสารทนาย",
   "ทนาย Notary",
   "รับรองลายมือชื่อ",
   "Apostille Thailand",
   "Affidavit Bangkok",
   "Power of Attorney Notary"
  ],
  "priceFrom": 1500,
  "priceTo": 8000,
  "turnaround": "เสร็จในวันเดียว · เร่งด่วนภายใน 1 ชั่วโมง",
  "coverage": "กรุงเทพ + 4 สาขา + ทั่วประเทศ (ส่ง EMS)",
  "languagesCount": 50,
  "relatedServiceIds": [
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "police-clearance"
  ],
  "faqCount": 13
 },
 "naati": {
  "id": "naati",
  "slug": "naati",
  "nameTh": "บริการแปลและรับรอง NAATI (Australia) — Online ทั่วโลก",
  "nameEn": "NAATI Certified Translation Australia (Online Worldwide)",
  "shortTh": "นักแปล NAATI Certified ออสเตรเลีย · ใช้ยื่นวีซ่า/มหาวิทยาลัย/Migration",
  "taglineTh": "นักแปล NAATI Certified ออสเตรเลียโดยตรง รับงานออนไลน์ส่งทั่วโลก ใช้ยื่น Migration Visa, AHPRA, มหาวิทยาลัย, ใบขับขี่, Centrelink และ Department of Home Affairs ได้ทันที",
  "taglineEn": "Direct NAATI-certified translators in Thailand and Australia. Online turnaround for migration, university, AHPRA, license conversion, and Department of Home Affairs submissions worldwide.",
  "metaTitle": "NAATI แปลรับรองออสเตรเลีย Online ทั่วโลก | NYC Legal NAATI",
  "metaDesc": "บริการแปล NAATI Certified Australia — แปลโดยนักแปลขึ้นทะเบียน NAATI ใช้ยื่นวีซ่าออสเตรเลีย/มหาวิทยาลัย/AHPRA — เริ่มต้นง่าย ๆ แค่ทักไลน์ เราดูแลจนจบทุกขั้นตอน",
  "keywords": [
   "NAATI Translation",
   "NAATI Certified Translator",
   "แปล NAATI",
   "NAATI Thai to English",
   "NAATI Online",
   "Migration Australia Translation",
   "AHPRA Translation",
   "Department of Home Affairs Translation"
  ],
  "priceFrom": 1300,
  "priceTo": 2500,
  "turnaround": "1–3 วันทำการ · เร่งด่วน 24 ชม.",
  "coverage": "ออนไลน์ทั่วโลก — ส่ง PDF/ไปรษณีย์ได้ทุกประเทศ",
  "languagesCount": 30,
  "relatedServiceIds": [
   "translation",
   "notary-public",
   "police-clearance",
   "embassy-legalization"
  ],
  "faqCount": 13
 },
 "police-clearance": {
  "id": "police-clearance",
  "slug": "police-clearance",
  "nameTh": "บริการขอตรวจสอบประวัติอาชญากรรม (Police Clearance) สำหรับคนไทย",
  "nameEn": "Police Clearance Certificate Service for Thai Nationals",
  "shortTh": "Police Clearance ตรวจประวัติคนไทย · ใช้ในไทย/ต่างประเทศ · ครบทุกวัตถุประสงค์",
  "taglineTh": "บริการขอใบตรวจสอบประวัติอาชญากรรมสำนักงานตำรวจแห่งชาติ — ครอบคลุมทุกวัตถุประสงค์: วีซ่า ทำงานต่างประเทศ ขอ PR แต่งงาน รับเลี้ยงบุตรบุญธรรม สมัครงานราชการ พร้อมแปลและรับรองครบวงจร",
  "taglineEn": "Police Clearance Certificate (PCC) service for Thai nationals worldwide — for visa, work permit, PR, citizenship, marriage, adoption, and employment, with end-to-end translation and legalization.",
  "metaTitle": "ตรวจประวัติอาชญากรรม Police Clearance ทั่วโลก | NYC Legal",
  "metaDesc": "บริการขอ Police Clearance Certificate สำหรับคนไทยทั่วประเทศและทั่วโลก — ใช้ยื่นวีซ่า/Migration/PR/แต่งงาน/รับเ — ส่งภาพเอกสารมาเช็กให้ก่อน ฟรี ไม่คิดค่าปรึกษา",
  "keywords": [
   "Police Clearance Thailand",
   "ตรวจประวัติอาชญากรรม",
   "ขอใบประวัติตำรวจ",
   "Police Clearance Visa",
   "ใบรับรองความประพฤติ",
   "Criminal Record Check Thailand",
   "ตรวจประวัติสำหรับวีซ่า",
   "Police Clearance Bangkok"
  ],
  "priceFrom": 2000,
  "priceTo": 8000,
  "turnaround": "ใช้ในไทย 3–7 วัน · ใช้ต่างประเทศ 7–14 วัน",
  "coverage": "ทั่วประเทศไทย + ลูกค้าไทยในต่างประเทศ (ทุกประเทศ)",
  "languagesCount": 50,
  "relatedServiceIds": [
   "translation",
   "naati",
   "mfa-legalization",
   "embassy-legalization"
  ],
  "faqCount": 13
 },
 "mfa-legalization": {
  "id": "mfa-legalization",
  "slug": "mfa-legalization",
  "nameTh": "บริการรับรองเอกสารกงสุลไทย กระทรวงการต่างประเทศ (MFA · นิติกรณ์ไทย)",
  "nameEn": "MFA / Consular Legalization (Thai Ministry of Foreign Affairs)",
  "shortTh": "รับรองกงสุล MFA · นิติกรณ์ไทย · ใช้ทุกสถานทูตและทุกประเทศปลายทาง",
  "taglineTh": "บริการนำเอกสารไปรับรองกงสุลและนิติกรณ์ที่กรมการกงสุล กระทรวงการต่างประเทศ — ครอบคลุมทุกชนิดเอกสาร: สูติบัตร ทะเบียนบ้าน ใบสมรส Transcript ใบรับรองบริษัท DBD ภพ.20 สำหรับใช้ในทุกประเทศทั่วโลก",
  "taglineEn": "Thai MFA (Ministry of Foreign Affairs) Consular Legalization and Notarial Certification — for civil, educational, corporate, and legal documents used worldwide.",
  "metaTitle": "รับรองกงสุล MFA นิติกรณ์ไทย ทุกเอกสาร | NYC Legal",
  "metaDesc": "บริการนำเอกสารไปรับรองกงสุล กระทรวงการต่างประเทศ (MFA / นิติกรณ์ไทย) — สูติบัตร ทะเบียนบ้าน ใบสมรส Transcrip — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที083-249-4999",
  "keywords": [
   "รับรองกงสุล",
   "MFA Legalization Thailand",
   "นิติกรณ์ไทย",
   "Consular Legalization Bangkok",
   "Thai MFA Authentication",
   "Apostille Thailand",
   "รับรองเอกสารกระทรวงต่างประเทศ",
   "Certified by Thai MFA"
  ],
  "priceFrom": 2500,
  "priceTo": 5000,
  "turnaround": "ปกติ 3 วันทำการ · เร่งด่วน 1 วัน",
  "coverage": "ทั่วประเทศไทย — ลูกค้าต่างประเทศส่งเอกสารผ่านสถานทูต/ไปรษณีย์ได้",
  "languagesCount": 50,
  "relatedServiceIds": [
   "embassy-legalization",
   "translation",
   "notary-public",
   "police-clearance"
  ],
  "faqCount": 13
 },
 "embassy-legalization": {
  "id": "embassy-legalization",
  "slug": "embassy-legalization",
  "nameTh": "บริการรับรองเอกสารโดยสถานทูตทุกประเทศทั่วโลก",
  "nameEn": "Embassy Legalization Service (All Embassies Worldwide)",
  "shortTh": "รับรองสถานทูตครบวงจร 80+ สถานทูตในไทย · สำหรับใช้ในทุกประเทศ",
  "taglineTh": "บริการนำเอกสารไปรับรองที่สถานทูตทุกประเทศในกรุงเทพ — สถานทูตจีน อินเดีย UAE ซาอุดิอาระเบีย ฝรั่งเศส เยอรมัน ญี่ปุ่น เกาหลี และอีกกว่า 80 สถานทูต ครบวงจรทั้ง Legalization Chain",
  "taglineEn": "End-to-end embassy legalization with all 80+ embassies in Bangkok — China, India, UAE, Saudi Arabia, France, Germany, Japan, Korea, and more. Full legalization chain from MFA to destination country embassy.",
  "metaTitle": "รับรองสถานทูตทุกประเทศ Embassy Legalization | NYC Legal",
  "metaDesc": "บริการนำเอกสารไปรับรองที่สถานทูตทุกประเทศในกรุงเทพ — จีน UAE ซาอุฯ อินเดีย ฝรั่งเศส เยอรมัน ญี่ปุ่น เกาหลี — คุยกับผู้เชี่ยวชาญตัวจริง ตอบกลับภายในไม่กี่นาที083-249-4999",
  "keywords": [
   "รับรองสถานทูต",
   "Embassy Legalization Thailand",
   "Embassy Authentication Bangkok",
   "รับรองเอกสารสถานทูตจีน",
   "รับรองเอกสารสถานทูต UAE",
   "Saudi Embassy Legalization",
   "China Consulate Authentication",
   "Document Legalization Thailand"
  ],
  "priceFrom": 5000,
  "priceTo": 12000,
  "turnaround": "3–14 วันทำการ ขึ้นกับสถานทูต",
  "coverage": "80+ สถานทูตในกรุงเทพมหานคร · ลูกค้าทั่วประเทศและทั่วโลก",
  "languagesCount": 50,
  "relatedServiceIds": [
   "mfa-legalization",
   "translation",
   "notary-public",
   "police-clearance"
  ],
  "faqCount": 13
 },
 "visa-thai-citizens": {
  "id": "visa-thai-citizens",
  "slug": "visa-thai-citizens",
  "nameTh": "บริการให้คำปรึกษาและยื่นวีซ่าทั่วโลกสำหรับคนไทย",
  "nameEn": "Global Visa Application & Consulting for Thai Citizens",
  "shortTh": "วีซ่า Schengen · UK · US · Australia · Canada · Japan · China · ทั่วโลก",
  "taglineTh": "ปรึกษา-เตรียมเอกสาร-จองคิว-ยื่นวีซ่า ครบทุกประเทศทั่วโลก โดยทีมที่ปรึกษามืออาชีพและทนาย Notary Public 6 ท่าน รวมแปล + รับรองกงสุล + รับรองสถานทูตในที่เดียว ลดความเสี่ยงปฏิเสธวีซ่า 90%",
  "taglineEn": "End-to-end visa consulting for Thai citizens applying to any country: document prep, translation, MFA legalization, embassy appointments, interview coaching.",
  "metaTitle": "บริการยื่นวีซ่าทั่วโลกสำหรับคนไทย — Schengen UK US Australia Japan China | NYC Legal",
  "metaDesc": "บริการปรึกษาและยื่นวีซ่าครบทุกประเทศ — Schengen, UK, USA, Canada, Australia, Japan, Korea, China, นิวซีแลนด์ ครบจบในที่เดียว แปล+รับรองกงสุล+สถานทูต+โค้ชสัมภาษณ์ ตอบใน 15 นาที โทร 083-249-4999",
  "keywords": [
   "ยื่นวีซ่า",
   "บริการทำวีซ่า",
   "วีซ่า Schengen",
   "วีซ่าอเมริกา",
   "วีซ่าอังกฤษ",
   "วีซ่าออสเตรเลีย",
   "วีซ่าญี่ปุ่น",
   "วีซ่าจีน",
   "วีซ่าแคนาดา",
   "ที่ปรึกษาวีซ่า",
   "Visa Consultant Thailand",
   "Visa Application Service"
  ],
  "priceFrom": 3500,
  "priceTo": 25000,
  "turnaround": "ปรึกษาทันที · เตรียมเอกสาร 3–7 วัน · ตามคิวสถานทูต",
  "coverage": "ปรึกษา-ยื่นวีซ่าทั่วโลก · ทุกพื้นที่ในไทย",
  "languagesCount": 50,
  "relatedServiceIds": [
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "police-clearance"
  ],
  "faqCount": 12
 },
 "visa-foreigners-thailand": {
  "id": "visa-foreigners-thailand",
  "slug": "visa-foreigners-thailand",
  "nameTh": "บริการวีซ่า & Work Permit สำหรับชาวต่างชาติในประเทศไทย",
  "nameEn": "Thailand Visa & Work Permit Service for Foreigners",
  "shortTh": "Non-B · Non-O · Retirement · Marriage · Elite · DTV · LTR · Work Permit · 90-Day",
  "taglineTh": "บริการครบวงจรสำหรับชาวต่างชาติ — Visa Extension, Re-entry Permit, Work Permit, 90-Day Report, Change of Visa Status, Permanent Residency โดยทีมที่ปรึกษา 2 ภาษา (TH/EN) + ทนาย Notary Public 6 ท่าน",
  "taglineEn": "End-to-end Thailand visa, work permit, and immigration service for foreigners — Non-B, Non-O Marriage/Retirement, Elite Visa, DTV Digital Nomad, LTR Long-Term Resident, PR & Citizenship. Bilingual English/Thai team, fully remote-friendly.",
  "metaTitle": "Thailand Visa & Work Permit Service for Foreigners — Non-B, Retirement, Marriage, LTR, DTV | NYC Legal",
  "metaDesc": "Full-service Thai visa & work permit consulting for foreigners — Non-B, Non-O (Marriage/Retirement), Elite, DTV Digital Nomad, LTR, Work Permit, 90-day report, PR & Citizenship. English-speaking lawyers. Call 083-249-4999",
  "keywords": [
   "Thailand visa for foreigners",
   "Thai work permit",
   "Non-B visa Thailand",
   "Non-O marriage visa",
   "Non-O retirement visa",
   "Thailand Elite visa",
   "DTV Digital Nomad visa Thailand",
   "LTR Long Term Resident visa",
   "90 day report Thailand",
   "Thai visa extension",
   "Thai PR application",
   "Thai citizenship",
   "Bangkok immigration lawyer",
   "Phuket visa agent",
   "Chiang Mai visa service",
   "Pattaya retirement visa",
   "วีซ่าชาวต่างชาติในไทย",
   "Work Permit ต่างชาติ",
   "ขอวีซ่าแต่งงานไทย",
   "วีซ่าเกษียณอายุไทย"
  ],
  "priceFrom": 4500,
  "priceTo": 95000,
  "turnaround": "Consultation same day · Document prep 3–7 days · Immigration queue dependent",
  "coverage": "Bangkok, Pattaya, Phuket, Chiang Mai, Samui, Hua Hin, Krabi, Udon Thani, Khon Kaen — nationwide",
  "languagesCount": 50,
  "relatedServiceIds": [
   "translation",
   "notary-public",
   "embassy-legalization",
   "mfa-legalization"
  ],
  "faqCount": 13
 },
 "marriage-thai-foreign": {
  "id": "marriage-thai-foreign",
  "slug": "marriage-thai-foreign",
  "nameTh": "บริการจดทะเบียนสมรสไทย–ต่างชาติครบวงจร",
  "nameEn": "Thai-Foreign Marriage Registration Service (End-to-End)",
  "shortTh": "จดทะเบียนสมรสกับชาวต่างชาติทั้งในไทยและต่างประเทศ ครบทุกขั้นตอน",
  "taglineTh": "ทีมทนายดูแลตั้งแต่ขอ Affidavit ที่สถานทูต · แปล/รับรอง MFA · จดทะเบียนสมรสที่อำเภอ · รับรองทะเบียนสมรสนำไปใช้ต่างประเทศ · สัญญาก่อนสมรส (Prenuptial Agreement) ครบในที่เดียว",
  "taglineEn": "Full-service Thai-Foreign marriage registration: embassy affidavit, certified translation, MFA legalization, district registration, and post-marriage document legalization for use abroad.",
  "metaTitle": "จดทะเบียนสมรสไทย–ต่างชาติ ครบวงจร | NYC Legal",
  "metaDesc": "บริการจดทะเบียนสมรสไทย–ต่างชาติ ดำเนินการครบทุกขั้นตอน — Affidavit สถานทูต แปล รับรอง MFA จดที่อำเภอ พร้อมรับรองทะเบียนสมรสนำไปใช้ต่างประเทศ ตอบใน 15 นาที โทร 083-249-4999",
  "keywords": [
   "จดทะเบียนสมรสไทยต่างชาติ",
   "จดทะเบียนสมรสกับชาวต่างชาติ",
   "Affidavit สถานทูต",
   "Marriage Registration Thailand",
   "Thai Foreign Marriage Lawyer",
   "Prenuptial Agreement Thailand",
   "K1 Visa Thailand",
   "Spouse Visa Marriage"
  ],
  "priceFrom": 4500,
  "priceTo": 45000,
  "turnaround": "Affidavit 1–3 วัน · ครบทุกขั้นตอน 7–14 วัน",
  "coverage": "ทั่วประเทศไทย + ดำเนินการที่ต่างประเทศได้",
  "languagesCount": 50,
  "relatedServiceIds": [
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "visa-thai-citizens"
  ],
  "faqCount": 15
 },
 "interpreter": {
  "id": "interpreter",
  "slug": "interpreter",
  "nameTh": "บริการล่ามแปลภาษา (ศาล · ตม. · ธุรกิจ · การแพทย์)",
  "nameEn": "Professional Interpreter Service (Court · Immigration · Business · Medical)",
  "shortTh": "ล่ามมืออาชีพ 50+ ภาษา สำหรับงานราชการ ศาล ธุรกิจ และการแพทย์",
  "taglineTh": "ล่ามขึ้นทะเบียนศาลยุติธรรม · ล่ามสำนักงานเขต/อำเภอ · ล่ามตำรวจ/ตม. · ล่ามประชุมธุรกิจ · ล่ามทางการแพทย์ · ล่ามไกล่เกลี่ย ครอบคลุม 50+ ภาษา รับงานเร่งด่วนใน 4 ชั่วโมง",
  "taglineEn": "Court-certified, immigration-approved, and business interpreters in 50+ languages — on-site, remote, and conference settings, with same-day rush deployment in Bangkok.",
  "metaTitle": "บริการล่ามแปลภาษา 50+ ภาษา ศาล ตม. ธุรกิจ | NYC Legal",
  "metaDesc": "บริการล่ามมืออาชีพ 50+ ภาษา ล่ามศาล · ล่ามจดทะเบียนสมรส · ล่ามตม./ตำรวจ · ล่ามประชุมธุรกิจ · ล่ามแพทย์ /ครั — คุยกับผู้เชี่ยวชาญตัวจริง ตอบกลับภายในไม่กี่นาที083-249-4999",
  "keywords": [
   "บริการล่ามแปลภาษา",
   "ล่ามศาล",
   "ล่ามจดทะเบียนสมรส",
   "ล่ามตำรวจ ตม.",
   "ล่ามประชุมธุรกิจ",
   "Court Interpreter Thailand",
   "Business Interpreter Bangkok",
   "Medical Interpreter Service",
   "Simultaneous Interpreter Thailand"
  ],
  "priceFrom": 2500,
  "priceTo": 35000,
  "turnaround": "จัดล่ามได้ใน 4–24 ชั่วโมง",
  "coverage": "ทั่วประเทศไทย + Remote ทั่วโลก (Zoom/Teams/Webex)",
  "languagesCount": 50,
  "relatedServiceIds": [
   "translation",
   "marriage-thai-foreign",
   "notary-public",
   "visa-foreigners-thailand"
  ],
  "faqCount": 13
 },
 "apec-abtc": {
  "id": "apec-abtc",
  "slug": "apec-business-travel-card",
  "nameTh": "บริการขอบัตรเดินทาง APEC Business Travel Card (ABTC)",
  "nameEn": "APEC Business Travel Card (ABTC) Application Service",
  "shortTh": "บัตร ABTC อายุ 5 ปี · เดินทาง 19 เขตเศรษฐกิจ APEC · ไม่ต้องขอวีซ่า · ช่อง APEC Lane",
  "taglineTh": "บริการขอบัตร APEC Business Travel Card ครบวงจรสำหรับนักธุรกิจไทยและผู้บริหาร — ยื่นคำขอผ่านกรมการกงสุล รวบรวม pre-clearance จาก 19 เขตเศรษฐกิจ APEC พร้อมเอกสารบริษัทรับรอง MFA และคำแปลครบชุด",
  "taglineEn": "Full-service APEC Business Travel Card (ABTC) application for Thai executives — visa-free entry to 19 APEC economies, dedicated APEC Lane at immigration, 5-year validity, multiple-entry.",
  "metaTitle": "ขอบัตร APEC Business Travel Card (ABTC) ครบวงจร | NYC Legal",
  "metaDesc": "บริการขอบัตร APEC Business Travel Card (ABTC) อายุ 5 ปี เดินทาง 19 เขต APEC ไม่ต้องขอวีซ่า ใช้ช่อง APEC Lane — เตรียมเอกสารบริษัท + แปล + นิติกรณ์ MFA + ยื่นกรมการกงสุล โทร 083-249-4999",
  "keywords": [
   "APEC Card",
   "APEC Business Travel Card",
   "ABTC",
   "บัตร APEC",
   "ขอบัตร APEC",
   "บัตรนักธุรกิจ APEC",
   "APEC Lane",
   "APEC Card Thailand"
  ],
  "priceFrom": 12000,
  "priceTo": 35000,
  "turnaround": "ดำเนินการ 3–6 เดือน (รวม pre-clearance 19 เขต)",
  "coverage": "ทั่วประเทศไทย — ยื่นที่กรมการกงสุล (แจ้งวัฒนะ)",
  "languagesCount": 19,
  "relatedServiceIds": [
   "visa-thai-citizens",
   "mfa-legalization",
   "notary-public",
   "translation"
  ],
  "faqCount": 13
 },
 "apostille": {
  "id": "apostille",
  "slug": "apostille",
  "nameTh": "บริการรับรองเอกสาร Apostille (ไทยเข้าร่วม Hague Convention)",
  "nameEn": "Apostille Certification Service Thailand",
  "shortTh": "Apostille ไทย — รับรองครั้งเดียว ใช้ได้ทั่ว 130 ประเทศสมาชิก Hague",
  "taglineTh": "ไทยเข้าร่วมอนุสัญญา Hague Apostille   เมื่อ 30 มิ.ย. 2569 (มีผลบังคับใช้กับไทย 28 ก.พ. 2570) — เอกสารราชการไทยรับรอง Apostille ครั้งเดียว ใช้ได้กับประเทศสมาชิกทั่วโลก ไม่ต้องวิ่งสถานทูตอีกต่อไป",
  "taglineEn": "Thailand officially joined the Hague Apostille Convention in Dec 2025. One Apostille stamp from MFA Thailand is now accepted in 125+ member states — no more embassy legalization.",
  "metaTitle": "บริการ Apostille ไทย รับรองเอกสาร Hague Convention | NYC Legal",
  "metaDesc": "Apostille ประเทศไทย — รับรองเอกสารราชการไทยภายใต้ Hague Convention ใช้ได้ 130 ประเทศ สูติบัตร ทะเบียนสมรส — คุยกับผู้เชี่ยวชาญตัวจริง ตอบกลับภายในไม่กี่นาที083-249-4999",
  "keywords": [
   "Apostille ประเทศไทย",
   "บริการ Apostille",
   "Apostille Thailand",
   "Hague Apostille Convention Thailand",
   "รับรองเอกสาร Apostille",
   "MFA Apostille",
   "Apostille สูติบัตร",
   "Apostille ปริญญาบัตร",
   "Apostille หนังสือรับรองบริษัท"
  ],
  "priceFrom": 2500,
  "priceTo": 12000,
  "turnaround": "เร่งด่วน 1 วัน · มาตรฐาน 3–5 วันทำการ",
  "coverage": "ทั่วประเทศไทย + จัดส่งทั่วโลก (Apostille ใช้ได้ 130 ประเทศ)",
  "languagesCount": 50,
  "relatedServiceIds": [
   "mfa-legalization",
   "embassy-legalization",
   "translation",
   "notary-public"
  ],
  "faqCount": 15
 },
 "tm30-90day": {
  "id": "tm30-90day",
  "slug": "tm30-90day-report",
  "nameTh": "บริการแจ้ง TM30 และรายงานตัว 90 วัน (Immigration Reporting)",
  "nameEn": "TM30 & 90-Day Report Immigration Service",
  "shortTh": "TM30 + 90-Day Report — ยื่นแทนทั่วไทย ออนไลน์/ออฟไลน์ ครบ ไม่โดนปรับ ฿2,000–฿800,000",
  "taglineTh": "บริการแจ้งที่พักอาศัย TM30 และรายงานตัวทุก 90 วันสำหรับชาวต่างชาติในไทย — ยื่นแทนทั่วประเทศ ทั้งออนไลน์ (e-Notification) และที่ ตม. แจ้งทันเวลา ไม่โดนค่าปรับ ฿2,000–฿800,000 พร้อมระบบเตือนล่วงหน้า 14 วันตลอดอายุวีซ่า",
  "taglineEn": "TM30 (residence notification) and 90-day report filing for foreigners in Thailand. We file via e-Notification or in-person at Immigration nationwide, with 14-day reminders to avoid the THB 2,000–800,000 penalty under Immigration Act B.E. 2522.",
  "metaTitle": "บริการ TM30 + รายงานตัว 90 วัน ยื่นแทนชาวต่างชาติ | NYC Legal",
  "metaDesc": "ยื่น TM30 และรายงานตัว 90 วันแทน — ออนไลน์ (e-Notification) หรือที่ ตม. ทั่วประเทศ ไม่โดนปรับ / พร้อมระบบเตือนอัต — ทีมงานตอบไวทุกวัน ปรึกษาก่อนตัดสินใจได้ฟรี083-249-4999",
  "keywords": [
   "TM30",
   "TM. 30",
   "แจ้งที่พักชาวต่างชาติ",
   "รายงานตัว 90 วัน",
   "90 day report Thailand",
   "TM47",
   "e-Notification immigration",
   "บริการยื่น TM30 แทน",
   "บริการรายงานตัว 90 วันแทน",
   "Immigration reporting Thailand",
   "Section 37 Immigration Act"
  ],
  "priceFrom": 900,
  "priceTo": 25000,
  "turnaround": "ยื่นออนไลน์ 24 ชม. · ที่ ตม. 1–2 วันทำการ",
  "coverage": "ทั่วประเทศ — ตม. กรุงเทพ (แจ้งวัฒนะ/ศูนย์ราชการ) · เชียงใหม่ · ภูเก็ต · พัทยา · หัวหิน · สมุย · ทุกจังหวัด",
  "languagesCount": 10,
  "relatedServiceIds": [
   "visa-foreigners-thailand",
   "marriage-thai-foreign",
   "translation",
   "notary-public"
  ],
  "faqCount": 14
 },
 "work-permit-boi": {
  "id": "work-permit-boi",
  "slug": "work-permit-boi-single-window",
  "nameTh": "บริการขอใบอนุญาตทำงาน Work Permit + BOI Single Window",
  "nameEn": "Work Permit + BOI Single Window Service",
  "shortTh": "ใบอนุญาตทำงาน + Non-B Visa + BOI/IEAT One-Stop ครบจบในที่เดียว",
  "taglineTh": "บริการขอ Work Permit แบบครบวงจร ทั้งช่องทาง กรมการจัดหางาน (DOE) และ BOI/IEAT Single Window สำหรับบริษัทส่งเสริมการลงทุน — รวม Non-B Visa, 90-Day Report, TM30, ต่ออายุ และเปลี่ยนนายจ้าง พร้อมทนายและที่ปรึกษากฎหมายแรงงานต่างด้าวประจำทีม",
  "taglineEn": "End-to-end Work Permit processing via DOE and BOI/IEAT Single Window. Covers Non-B visa, 90-day report, TM30, renewals, and employer transfer for foreigners working in Thailand.",
  "metaTitle": "บริการขอ Work Permit + BOI Single Window | NYC Legal",
  "metaDesc": "ขอใบอนุญาตทำงาน Work Permit + Non-B Visa + BOI Single Window ครบจบ บริการทั่วประเทศ ต่ออายุ/เปลี่ยนนายจ้าง/D — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที083-249-4999",
  "keywords": [
   "Work Permit Thailand",
   "ใบอนุญาตทำงาน",
   "Non-B Visa",
   "BOI Single Window",
   "BOI Work Permit",
   "IEAT Work Permit",
   "Digital Work Permit",
   "ต่อ Work Permit",
   "เปลี่ยนนายจ้าง Work Permit",
   "ขอ WP3",
   "WP10 BOI",
   "Foreign worker permit Thailand"
  ],
  "priceFrom": 15000,
  "priceTo": 120000,
  "turnaround": "BOI Single Window 3 ชม. · DOE 7–10 วันทำการ",
  "coverage": "ทั่วประเทศ — DOE กรุงเทพ/ภูธร · BOI One Stop Service Center (จัตุรัสจามจุรี) · IEAT (นิคมอุตสาหกรรม)",
  "languagesCount": 10,
  "relatedServiceIds": [
   "visa-foreigners-thailand",
   "tm30-90day",
   "translation",
   "mfa-legalization"
  ],
  "faqCount": 14
 },
 "permanent-residence": {
  "id": "permanent-residence",
  "slug": "permanent-residence-thailand",
  "nameTh": "บริการขอใบสำคัญถิ่นที่อยู่ (Permanent Residence) ในประเทศไทย",
  "nameEn": "Thai Permanent Residence (PR) Application Service",
  "shortTh": "ขอ PR ไทย — Quota รายปี · 5 ประเภท · ใบสำคัญถิ่นที่อยู่เล่มแดง + ใบสำคัญประจำตัวคนต่างด้าว",
  "taglineTh": "บริการที่ปรึกษากฎหมายและดำเนินการขอใบสำคัญถิ่นที่อยู่ (Permanent Residence) ตามมาตรา 41 พ.ร.บ.คนเข้าเมือง พ.ศ. 2522 — ครอบคลุมทั้ง 5 ประเภท (Investment · Working · Family · Expert · Other) จัดทำเอกสารคะแนน เตรียมสัมภาษณ์ภาษาไทย ติดตามผลกับสำนักงานตรวจคนเข้าเมืองและกระทรวงมหาดไทย พร้อมต่อยอดสู่การขอสัญชาติไทย",
  "taglineEn": "End-to-end Thai Permanent Residence application service across all 5 categories. Covers point scoring, Thai language interview prep, and follow-up with Immigration Bureau and Ministry of Interior.",
  "metaTitle": "ขอ PR ไทย (Permanent Residence) — Quota ครบ 5 ประเภท | NYC Legal",
  "metaDesc": "บริการขอใบสำคัญถิ่นที่อยู่ Permanent Residence ประเทศไทย — Investment / Working / Family / Expert ที่ปรึกษาก — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที083-249-4999",
  "keywords": [
   "Permanent Residence Thailand",
   "ใบสำคัญถิ่นที่อยู่",
   "PR ไทย",
   "ขอ PR ประเทศไทย",
   "Thai PR quota",
   "ใบสำคัญประจำตัวคนต่างด้าว",
   "Alien Registration Book",
   "ใบต่างด้าว",
   "PR investment Thailand",
   "PR working Thailand",
   "ขอสัญชาติไทย",
   "Thai citizenship application"
  ],
  "priceFrom": 150000,
  "priceTo": 450000,
  "turnaround": "12–24 เดือน (ตามรอบ Quota ตม. ปกติเปิดปลายปี ต.ค.–ธ.ค.)",
  "coverage": "ทั่วประเทศ — สำนักงานตรวจคนเข้าเมือง แจ้งวัฒนะ + กระทรวงมหาดไทย",
  "languagesCount": 10,
  "relatedServiceIds": [
   "work-permit-boi",
   "visa-foreigners-thailand",
   "marriage-thai-foreign",
   "police-clearance"
  ],
  "faqCount": 15
 },
 "thai-citizenship": {
  "id": "thai-citizenship",
  "slug": "thai-citizenship",
  "nameTh": "บริการขอสัญชาติไทย (Thai Citizenship / Naturalization)",
  "nameEn": "Thai Citizenship & Naturalization Service",
  "shortTh": "ขอสัญชาติไทยตามมาตรา 9–11 พ.ร.บ.สัญชาติ — Naturalization · คู่สมรส · บุตร · ฟื้นฟูสัญชาติ",
  "taglineTh": "บริการที่ปรึกษากฎหมายและดำเนินการขอสัญชาติไทย (Naturalization) ครบวงจรตาม พ.ร.บ.สัญชาติ พ.ศ. 2508 และที่แก้ไขเพิ่มเติม — ครอบคลุมทั้งกรณีถือ PR ครบ 5 ปี · คู่สมรสคนไทยตามมาตรา 9 · บุตรของผู้ได้สัญชาติ · ฟื้นฟูสัญชาติเดิม พร้อมติวเพลงชาติ-สรรเสริญพระบารมี ภาษาไทยขั้นกลาง และเตรียมสัมภาษณ์ Special Branch ติดตามผลกับกองสัญชาติ กรมการปกครอง กระทรวงมหาดไทย และคณะรัฐมนตรี",
  "taglineEn": "End-to-end Thai Naturalization service across all categories — PR holders (5+ years), Thai spouses (Section 9), children of naturalized persons, and citizenship restoration. Includes Thai language, national anthem coaching, and Special Branch interview preparation.",
  "metaTitle": "ขอสัญชาติไทย Naturalization — ครบวงจรทุกประเภท | NYC Legal",
  "metaDesc": "บริการขอสัญชาติไทย Naturalization ตาม พ.ร.บ.สัญชาติ พ.ศ. 2508 — PR 5 ปี / คู่สมรสคนไทย / บุตร / ฟื้นฟูสัญชาติ ติว — ปรึกษาฟรี ประเมินงานให้ทันที ทักไลน์ได้เลย083-249-4999",
  "keywords": [
   "ขอสัญชาติไทย",
   "Thai Citizenship",
   "Thai Naturalization",
   "Naturalization Thailand",
   "สัญชาติไทยคู่สมรส",
   "ขอสัญชาติไทยมาตรา 9",
   "ขอสัญชาติไทยมาตรา 10",
   "Thai citizenship by marriage",
   "ฟื้นฟูสัญชาติไทย",
   "หนังสือเดินทางไทย",
   "Thai passport application",
   "บัตรประชาชนไทยสำหรับต่างชาติ"
  ],
  "priceFrom": 250000,
  "priceTo": 550000,
  "turnaround": "2–5 ปี (มท. + ครม. + ราชกิจจานุเบกษา)",
  "coverage": "ทั่วประเทศ — กองสัญชาติ กรมการปกครอง · กระทรวงมหาดไทย · Special Branch ตำรวจสันติบาล",
  "languagesCount": 10,
  "relatedServiceIds": [
   "permanent-residence",
   "marriage-thai-foreign",
   "translation",
   "mfa-legalization"
  ],
  "faqCount": 14
 },
 "company-boi": {
  "id": "company-boi",
  "slug": "company-boi",
  "nameTh": "บริการจดทะเบียนบริษัท + BOI Promotion ครบวงจร",
  "nameEn": "Company Registration & BOI Promotion Service",
  "shortTh": "จดบริษัท DBD · ขอบัตรส่งเสริม BOI · IEAT · EEC · LTR Visa · Foreign Business License",
  "taglineTh": "บริการที่ปรึกษากฎหมายและดำเนินการจดทะเบียนบริษัทจำกัด/บจม./Limited Partnership ทุกประเภท ตามประมวลกฎหมายแพ่งและพาณิชย์ และ พ.ร.บ.บริษัทมหาชน — พร้อมขอบัตรส่งเสริมการลงทุน BOI (สิทธิยกเว้นภาษี 3–13 ปี · ถือหุ้นต่างชาติ 100% · ที่ดิน · Work Permit Single Window) · IEAT · EEC · Foreign Business License (FBL) ตาม พ.ร.บ.การประกอบธุรกิจของคนต่างด้าว พ.ศ. 2542 · ขอ LTR Visa 10 ปีสำหรับ Wealthy Pensioner/Global Citizen/Work-from-Thailand Professional/Highly-Skilled Professional · ครบจาก DBD → BOI → WP → VAT → Bookkeeping",
  "taglineEn": "End-to-end company incorporation and BOI promotion service — DBD registration (Ltd./Plc./LP), BOI investment promotion (tax holidays 3–13 years, 100% foreign ownership, land rights), IEAT, EEC, Foreign Business License (FBL), and LTR 10-year visa. From incorporation through licensing, work permits, VAT, and ongoing bookkeeping.",
  "metaTitle": "จดทะเบียนบริษัท + BOI Promotion · LTR Visa · FBL | NYC Legal",
  "metaDesc": "จดทะเบียนบริษัท DBD + ขอบัตรส่งเสริม BOI (ยกเว้นภาษี 13 ปี · ต่างชาติถือหุ้น 100% · LTR Visa) · IEAT · EEC · FBL — ทีมงานตอบไวทุกวัน ปรึกษาก่อนตัดสินใจได้ฟรี083-249-4999",
  "keywords": [
   "จดทะเบียนบริษัท",
   "Company Registration Thailand",
   "BOI Promotion",
   "BOI Application",
   "บัตรส่งเสริมการลงทุน",
   "Foreign Business License",
   "FBL Thailand",
   "LTR Visa",
   "Long-Term Resident Visa",
   "IEAT EEC",
   "จดบริษัทต่างชาติ",
   "Treaty of Amity"
  ],
  "priceFrom": 35000,
  "priceTo": 850000,
  "turnaround": "5–7 วัน (DBD) · 60–120 วัน (BOI) · 30–60 วัน (FBL/LTR)",
  "coverage": "ทั่วประเทศ — DBD · BOI · IEAT · EEC · MOC · กรมสรรพากร · กรมสวัสดิการและคุ้มครองแรงงาน",
  "languagesCount": 10,
  "relatedServiceIds": [
   "work-permit-boi",
   "visa-foreigners-thailand",
   "translation",
   "mfa-legalization"
  ],
  "faqCount": 14
 },
 "trademark-ip": {
  "id": "trademark-ip",
  "slug": "trademark-ip",
  "nameTh": "บริการจดทะเบียนเครื่องหมายการค้า + ทรัพย์สินทางปัญญาครบวงจร",
  "nameEn": "Trademark Registration & Intellectual Property Service",
  "shortTh": "เครื่องหมายการค้า · สิทธิบัตร · ลิขสิทธิ์ · Madrid Protocol · ฟ้องละเมิด",
  "taglineTh": "บริการจดทะเบียนเครื่องหมายการค้าทุกประเภท (Trademark/Service Mark/Collective/Certification) ที่กรมทรัพย์สินทางปัญญา (DIP) · ยื่นระหว่างประเทศผ่าน Madrid Protocol คุ้มครอง 130+ ประเทศ · จดสิทธิบัตรการประดิษฐ์/อนุสิทธิบัตร/สิทธิบัตรการออกแบบ · จดลิขสิทธิ์ · ความลับทางการค้า · ฟ้องคดีละเมิด IP ที่ศาลทรัพย์สินทางปัญญาและการค้าระหว่างประเทศกลาง (CIPITC) · Trademark Watch & Enforcement · ตรวจค้นชื่อทั่วโลกก่อนยื่น · บริการครบจบโดยทนายตัวแทนเครื่องหมายการค้าและสิทธิบัตรที่ขึ้นทะเบียน DIP",
  "taglineEn": "End-to-end trademark and intellectual property service — DIP filing (trademark/service mark/collective/certification), Madrid Protocol international filing (130+ countries), patent prosecution (invention/petty/design), copyright registration, trade secret protection, IP litigation at CIPITC court, trademark watch, and enforcement. Handled by DIP-registered trademark agents and patent attorneys.",
  "metaTitle": "จดเครื่องหมายการค้า + สิทธิบัตร + Madrid Protocol | NYC Legal IP",
  "metaDesc": "จดเครื่องหมายการค้า DIP · Madrid Protocol 130+ ประเทศ · สิทธิบัตร · ลิขสิทธิ์ · ฟ้องละเมิด IP ครบวงจร ทนายตัวแทนเ — ปรึกษาฟรี ประเมินงานให้ทันที ทักไลน์ได้เลย083-249-4999",
  "keywords": [
   "จดเครื่องหมายการค้า",
   "Trademark Registration Thailand",
   "Madrid Protocol",
   "สิทธิบัตร",
   "Patent Thailand",
   "จดลิขสิทธิ์",
   "Copyright Registration",
   "ตัวแทนเครื่องหมายการค้า",
   "ฟ้องละเมิดเครื่องหมายการค้า",
   "CIPITC",
   "Trademark Watch",
   "ทรัพย์สินทางปัญญา"
  ],
  "priceFrom": 8500,
  "priceTo": 450000,
  "turnaround": "10–14 เดือน (จดทะเบียน) · ตรวจค้น 1–2 วัน · ยื่น 1 สัปดาห์",
  "coverage": "ทั่วประเทศ + ระหว่างประเทศ — DIP · WIPO Madrid · USPTO · EUIPO · CNIPA · JPO · IPOS",
  "languagesCount": 10,
  "relatedServiceIds": [
   "company-boi",
   "notary-public",
   "translation",
   "mfa-legalization"
  ],
  "faqCount": 14
 },
 "sworn-translation": {
  "id": "sworn-translation",
  "slug": "sworn-translation",
  "nameTh": "บริการแปลรับรองโดยทนาย/ศาล + ล่ามศาล (Sworn Translation & Court Interpreter)",
  "nameEn": "Sworn Translation & Court Interpreter Service",
  "shortTh": "คำแปลรับรองศาล · ทนายลงนาม · ล่ามศาล · ล่ามสำนักงานอัยการ · DSI · ปคบ.",
  "taglineTh": "บริการแปลรับรองคำแปลโดยทนายความขึ้นทะเบียนสภาทนายความ + ล่ามศาลขึ้นทะเบียนศาลยุติธรรม รองรับเอกสาร/คดีทุกประเภท — คำพิพากษา · คำฟ้อง · คำให้การ · พยานเอกสาร · สัญญาที่ใช้ในศาล · เอกสาร DSI / ปคบ. / สำนักงานอัยการสูงสุด · พินัยกรรม/สัญญาประนีประนอม · บริการล่ามในชั้นสอบสวน-ไต่สวน-สืบพยาน-อนุญาโตตุลาการ (THAC/TAI/SIAC) · 30+ ภาษา · ทนาย/ล่ามผ่านการอบรมศาลยุติธรรม + ขึ้นทะเบียนรายชื่อล่ามอย่างเป็นทางการ",
  "taglineEn": "Sworn translation certified by Thai Bar-registered attorneys plus court interpreters listed in the official Court of Justice roster. We handle judgments, complaints, witness statements, evidence, court-bound contracts, DSI / ECD / OAG documents, wills, settlement agreements, and live interpretation for investigation, deposition, trial, and arbitration (THAC, TAI, SIAC, ICC). 30+ languages, attorneys and interpreters Court-trained and Court-listed.",
  "metaTitle": "แปลรับรองโดยทนาย + ล่ามศาล Sworn Translation/Court Interpreter | NYC Legal",
  "metaDesc": "แปลรับรองคำแปลโดยทนายขึ้นทะเบียนสภาทนายความ + ล่ามศาลขึ้นทะเบียนศาลยุติธรรม รองรับคดีแพ่ง อาญา ปกครอง อนุญาโ — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที083-249-4999",
  "keywords": [
   "แปลรับรองโดยทนาย",
   "Sworn Translation Thailand",
   "ล่ามศาล",
   "Court Interpreter Thailand",
   "ล่ามขึ้นทะเบียนศาลยุติธรรม",
   "ทนายรับรองคำแปล",
   "Certified Legal Translation",
   "แปลคำพิพากษา",
   "ล่ามอนุญาโตตุลาการ",
   "ล่าม DSI",
   "ล่าม ปคบ.",
   "Sworn Translator Thailand"
  ],
  "priceFrom": 1500,
  "priceTo": 250000,
  "turnaround": "1–3 วัน (แปล) · นัดล่ามล่วงหน้า 3–7 วัน · ฉุกเฉิน 24 ชม.",
  "coverage": "ศาลทั่วประเทศ — ศาลแพ่ง · ศาลอาญา · ศาลปกครอง · ศาลแรงงาน · ศาลภาษีอากร · ศาลทรัพย์สินทางปัญญา (CIPITC) · ศาลเยาวชน · DSI · ปคบ. · สำนักงานอัยการสูงสุด · THAC · TAI · อนุญาโตตุลาการระหว่างประเทศ",
  "languagesCount": 30,
  "relatedServiceIds": [
   "translation",
   "notary-public",
   "mfa-legalization",
   "trademark-ip"
  ],
  "faqCount": 14
 },
 "criminal-defense": {
  "id": "criminal-defense",
  "slug": "criminal-defense",
  "nameTh": "ทนายอาญา + คดียาเสพติด + ประกันตัว (Criminal Defense & Bail)",
  "nameEn": "Criminal Defense, Drug Cases & Bail Services",
  "shortTh": "ทนายอาญา · คดียาเสพติด · ประกันตัว · ปคบ. · DSI · ตม. · 24 ชม.",
  "taglineTh": "ทีมทนายอาญาเชี่ยวชาญทุกฐานความผิด — ยาเสพติด · ฉ้อโกง · ฟอกเงิน · ค้ามนุษย์ · ความผิดทาง Computer/Cyber · ความผิดเกี่ยวกับเพศ · ความผิดต่อทรัพย์ · คดี ตม. (Overstay/Blacklist) · คดี ปคบ./DSI · ความผิดตามกฎหมายพิเศษ — บริการครบวงจรตั้งแต่ชั้นจับกุม–สอบสวน–ฝากขัง–ประกันตัว–สืบพยาน–อุทธรณ์–ฎีกา · ทีมพร้อมรับสายฉุกเฉิน 24 ชม. ถึงสถานีตำรวจในกรุงเทพและปริมณฑลไม่เกิน 2 ชั่วโมง · ล่ามต่างประเทศ 30+ ภาษา · ประกันตัวด้วยหลักทรัพย์ของบริษัท (Bail Bond) เริ่ม ฿15,000",
  "taglineEn": "Full-spectrum criminal defense team — drug offenses, fraud, money laundering, human trafficking, cyber crime, sex offenses, property crime, immigration overstay/blacklist, ECD/DSI cases, and special-act offenses. End-to-end representation from arrest, interrogation, pre-trial detention, bail, witness examination, to appeal and Supreme Court. 24/7 emergency hotline reaching any Bangkok metro police station within 2 hours. Court interpreters in 30+ languages. Corporate bail bonds available from ฿15,000.",
  "metaTitle": "ทนายอาญา + คดียาเสพติด + ประกันตัว 24 ชม. Criminal Defense | NYC Legal",
  "metaDesc": "ทนายอาญาครบวงจร — คดียาเสพติด ฉ้อโกง ฟอกเงิน ตม. ปคบ. DSI · บริการประกันตัวด้วยหลักทรัพย์บริษัท · ทีมฉุกเฉิน 24 ชม — ปรึกษาฟรีก่อนยื่นจริง ลดโอกาสเอกสารตีกลับ083-249-4999",
  "keywords": [
   "ทนายอาญา",
   "Criminal Defense Lawyer Thailand",
   "ทนายคดียาเสพติด",
   "Drug Case Lawyer",
   "ประกันตัว",
   "Bail Bond Thailand",
   "ทนายฉ้อโกง",
   "ทนายฟอกเงิน",
   "ทนายคดี ปคบ.",
   "ทนายคดี DSI",
   "ทนายต่างชาติ",
   "Criminal Lawyer for Foreigners",
   "ทนาย Overstay",
   "ทนายฉุกเฉิน 24 ชั่วโมง"
  ],
  "priceFrom": 15000,
  "priceTo": 2500000,
  "turnaround": "ฉุกเฉิน 24 ชม. · ประกันตัว 2–6 ชม. · คดีเต็มรูปแบบ 6–18 เดือน",
  "coverage": "ทุกสถานีตำรวจ 1,482 แห่งทั่วประเทศ · ศาลอาญา · ศาลอาญาคดีทุจริต · ศาลแขวง · ศาลทหาร · DSI · ปคบ. · กองปราบ · กรมศุลกากร · ปปง. · ตม. ทุกด่าน · เรือนจำกลาง/พิเศษทั่วประเทศ",
  "languagesCount": 30,
  "relatedServiceIds": [
   "sworn-translation",
   "visa-foreigners-thailand",
   "notary-public",
   "trademark-ip"
  ],
  "faqCount": 14
 },
 "civil-family-probate": {
  "id": "civil-family-probate",
  "slug": "civil-family-probate",
  "nameTh": "ทนายแพ่ง · ครอบครัว · หย่า · มรดก (Civil Litigation, Family Law, Divorce, Probate)",
  "nameEn": "Civil Litigation, Family Law, Divorce & Probate Services",
  "shortTh": "ทนายแพ่ง · หย่า · สิทธิเลี้ยงดูบุตร · มรดก · Prenup · ครอบครัวข้ามชาติ",
  "taglineTh": "ทีมทนายแพ่ง-ครอบครัว-มรดก 16+ คน เชี่ยวชาญทุกประเภทคดี — หย่าโดยความยินยอม/ฟ้องหย่า · ฟ้องเรียกค่าอุปการะเลี้ยงดูบุตร · สิทธิปกครองและสิทธิพบบุตร · ฟ้องแบ่งสินสมรส · ทำสัญญาก่อนสมรส (Prenuptial Agreement) · จัดการมรดก/ตั้งผู้จัดการมรดก · พินัยกรรม · มรดกข้ามชาติ + Cross-border Probate · ฟ้องผิดสัญญา/ละเมิด/หนี้สิน · ฟ้องเรียกหนี้ + บังคับคดี · คดีที่ดิน/อสังหาฯ · คดีผู้บริโภค · รับรองบุตร · รับบุตรบุญธรรม · เปลี่ยนชื่อ-สกุล · ครอบครัวต่างชาติ Hague Convention",
  "taglineEn": "Comprehensive Civil, Family & Probate practice — uncontested/contested divorce, child support, custody and visitation, marital asset division, prenuptial and postnuptial agreements, estate administration, wills, cross-border probate, breach of contract, tort, debt collection and enforcement, real estate disputes, consumer cases, child legitimation, adoption, name change, and Hague Convention international family matters.",
  "metaTitle": "ทนายหย่า · มรดก · ครอบครัว · แพ่ง ครบวงจร | NYC Legal",
  "metaDesc": "ทนายแพ่ง · หย่า · สิทธิเลี้ยงดูบุตร · มรดก/พินัยกรรม · Prenup · Cross-border Probate · Hague Convention · ที — เริ่มต้นง่าย ๆ แค่ทักไลน์ เราดูแลจนจบทุกขั้นตอน083-249-4999",
  "keywords": [
   "ทนายหย่า",
   "Divorce Lawyer Thailand",
   "ทนายมรดก",
   "Probate Lawyer",
   "Prenuptial Agreement",
   "สัญญาก่อนสมรส",
   "สิทธิเลี้ยงดูบุตร",
   "Child Custody",
   "ฟ้องเรียกค่าอุปการะ",
   "Child Support",
   "ทนายฟ้องแพ่ง",
   "Civil Litigation Thailand",
   "ฟ้องผิดสัญญา",
   "Cross-border Probate",
   "Hague Convention Family",
   "International Divorce Thailand"
  ],
  "priceFrom": 8500,
  "priceTo": 1800000,
  "turnaround": "หย่ายินยอม 1–3 วัน · ฟ้องหย่า/มรดก 4–14 เดือน · Prenup 5–10 วัน",
  "coverage": "ศาลเยาวชนและครอบครัวกลาง · ศาลแพ่ง 5 แห่งใน กทม. · ศาลแขวง · ศาลทรัพย์สินทางปัญญาฯ · สำนักงานเขต/อำเภอทุกแห่ง · กรมการปกครอง · กรมที่ดิน · DSI · สถานทูตในไทย/ต่างประเทศ · Hague Conference on Private International Law",
  "languagesCount": 18,
  "relatedServiceIds": [
   "sworn-translation",
   "criminal-defense",
   "notary-public",
   "marriage-thai-foreign"
  ],
  "faqCount": 14
 },
 "real-estate-conveyancing": {
  "id": "real-estate-conveyancing",
  "slug": "real-estate-conveyancing",
  "nameTh": "นิติกรรมที่ดิน · โอนกรรมสิทธิ์ · Real Estate Conveyancing",
  "nameEn": "Real Estate Conveyancing & Land Transactions",
  "shortTh": "ตรวจโฉนด · ร่างสัญญาซื้อขาย · โอนกรรมสิทธิ์ · Foreign Condo Quota · Usufruct · Lease 30 ปี",
  "taglineTh": "ปิดดีลอสังหาฯ ปลอดภัย · ตรวจ Due Diligence ครบ · โอนกรรมสิทธิ์วันเดียวจบ",
  "taglineEn": "Safe Property Closing · Full Due Diligence · Same-Day Land Office Transfer",
  "metaTitle": "นิติกรรมที่ดิน โอนกรรมสิทธิ์ Real Estate Conveyancing | NYC Legal",
  "metaDesc": "ทนายอสังหาฯ ครบวงจร — ตรวจโฉนด · Due Diligence · ร่างสัญญา · Foreign Condo Quota · Usufruct · Lease 30 ปี — เริ่มต้นง่าย ๆ แค่ทักไลน์ เราดูแลจนจบทุกขั้นตอน",
  "keywords": [
   "ทนายอสังหาริมทรัพย์",
   "โอนกรรมสิทธิ์ที่ดิน",
   "Real Estate Conveyancing Thailand",
   "Foreign Condo Quota 49%",
   "Usufruct Thailand",
   "Lease 30 ปี ต่างชาติ",
   "ตรวจโฉนด Due Diligence",
   "ภาษีธุรกิจเฉพาะที่ดิน",
   "Land Office Transfer Lawyer",
   "นิติกรรมที่ดิน",
   "Sale and Purchase Agreement Thailand",
   "Property Lawyer Bangkok"
  ],
  "priceFrom": 15000,
  "priceTo": 3500000,
  "turnaround": "1–14 วันทำการ (Due Diligence 5–10 วัน · โอนกรรมสิทธิ์ 1 วัน)",
  "coverage": "กรมที่ดินทั่วประเทศ 461 สำนักงาน · BOI · กทม. 50 เขต + 77 จังหวัด",
  "languagesCount": 18,
  "relatedServiceIds": [
   "civil-family-probate",
   "notary-public",
   "company-boi",
   "marriage-thai-foreign"
  ],
  "faqCount": 13
 },
 "tax-law": {
  "id": "tax-law",
  "slug": "tax-law",
  "nameTh": "กฎหมายภาษีอากร · PIT · CIT · VAT · Transfer Pricing",
  "nameEn": "Tax Law · PIT/CIT/VAT Compliance + Transfer Pricing",
  "shortTh": "ภาษีบุคคล · นิติบุคคล · VAT · Transfer Pricing · BEPS · ภาษีระหว่างประเทศ · ฟ้องสรรพากร",
  "taglineTh": "ทนายภาษีอากร + อดีตสรรพากร — วางแผนภาษีถูกกฎหมาย ลดภาระสูงสุด ฟ้องคืนภาษีได้",
  "taglineEn": "Tax Lawyer + Ex-Revenue Officer — Legal Tax Planning · Tax Refund Litigation · BEPS 2.0",
  "metaTitle": "ทนายภาษีอากร PIT CIT VAT Transfer Pricing BEPS | NYC Legal",
  "metaDesc": "ทนายภาษีอากร + อดีตสรรพากร — วางแผนภาษี PIT CIT VAT · Transfer Pricing · BEPS 2.0 · DTA 60+ ประเทศ · ฟ้องสร — คุยกับผู้เชี่ยวชาญตัวจริง ตอบกลับภายในไม่กี่นาที",
  "keywords": [
   "ทนายภาษีอากร",
   "Tax Lawyer Thailand",
   "Transfer Pricing Thailand",
   "BEPS 2.0 Pillar Two",
   "ภาษีเงินได้บุคคลธรรมดา PIT",
   "ภาษีนิติบุคคล CIT",
   "VAT Refund",
   "Tax Audit Defense",
   "ฟ้องคืนภาษี",
   "ศาลภาษีอากรกลาง",
   "Double Tax Agreement",
   "ภาษีระหว่างประเทศ Cross-border Tax"
  ],
  "priceFrom": 15000,
  "priceTo": 4500000,
  "turnaround": "1–30 วันทำการ (Consult 1 วัน · Tax Return 3–7 วัน · Tax Audit Defense 30–180 วัน)",
  "coverage": "กรมสรรพากรทั่วประเทศ · BOI · ศาลภาษีอากรกลาง · DTA 60+ ประเทศ",
  "languagesCount": 12,
  "relatedServiceIds": [
   "company-boi",
   "real-estate-conveyancing",
   "civil-family-probate",
   "trademark-ip"
  ],
  "faqCount": 13
 },
 "labor-employment": {
  "id": "labor-employment",
  "slug": "labor-employment",
  "nameTh": "กฎหมายแรงงาน · เลิกจ้าง · Severance · ศาลแรงงาน",
  "nameEn": "Labor Law & Employment · Severance · Labor Court · Workplace Investigation",
  "shortTh": "ทนายแรงงาน · เลิกจ้างเป็นธรรม · ค่าชดเชย · Workplace Investigation · ศาลแรงงาน",
  "taglineTh": "ทนายแรงงานเฉพาะทาง — สู้ทั้งฝั่งนายจ้างและลูกจ้าง · Win Rate ศาลแรงงาน 81%",
  "taglineEn": "Specialized Labor Lawyers — Both Employer & Employee Side · 81% Labor Court Win Rate",
  "metaTitle": "ทนายแรงงาน เลิกจ้าง ค่าชดเชย ศาลแรงงาน Workplace Investigation | NYC Legal",
  "metaDesc": "ทนายแรงงานเฉพาะทาง 12+ คน — เลิกจ้างเป็นธรรม · ค่าชดเชย · Severance · Workplace Investigation · #MeToo · Union — ปรึกษาฟรี ประเมินงานให้ทันที ทักไลน์ได้เลย",
  "keywords": [
   "ทนายแรงงาน",
   "Labor Lawyer Thailand",
   "เลิกจ้างเป็นธรรม",
   "ค่าชดเชยเลิกจ้าง Severance Pay",
   "ศาลแรงงาน",
   "Workplace Investigation",
   "Sexual Harassment #MeToo",
   "Union Labor Relations",
   "Employment Contract",
   "Non-Compete NDA",
   "Mass Layoff Restructuring",
   "Wrongful Termination"
  ],
  "priceFrom": 9500,
  "priceTo": 2800000,
  "turnaround": "1–30 วันทำการ (Consult 1 วัน · เลิกจ้าง 7 วัน · ศาลแรงงาน 60–180 วัน)",
  "coverage": "ศาลแรงงานกลาง 12 ภาค · กรมสวัสดิการคุ้มครองแรงงาน 77 จังหวัด · สำนักงานประกันสังคม",
  "languagesCount": 14,
  "relatedServiceIds": [
   "company-boi",
   "tax-law",
   "civil-family-probate",
   "criminal-defense"
  ],
  "faqCount": 13
 },
 "banking-finance": {
  "id": "banking-finance",
  "slug": "banking-finance",
  "nameTh": "กฎหมายธนาคารและการเงิน · NPL · Debt Restructuring · Securities · SEC",
  "nameEn": "Banking & Finance Law · NPL · Debt Restructuring · Securities · SEC Compliance",
  "shortTh": "ทนายธนาคาร · ฟ้องลูกหนี้ NPL · ปรับโครงสร้างหนี้ · IPO · SEC · BOT Compliance",
  "taglineTh": "ทนายธนาคาร-การเงินครบวงจร — NPL · Restructuring · IPO · SEC · Fintech · Crypto License",
  "taglineEn": "Full-service Banking & Finance Lawyers — NPL · Restructuring · IPO · SEC · Fintech · Crypto",
  "metaTitle": "ทนายธนาคาร NPL ปรับโครงสร้างหนี้ Securities SEC IPO Fintech | NYC Legal",
  "metaDesc": "ทนายธนาคาร-การเงินเฉพาะทาง 15+ คน — ฟ้อง NPL · Debt Restructuring · Business Rehabilitation · IPO · SEC · BO — เริ่มต้นง่าย ๆ แค่ทักไลน์ เราดูแลจนจบทุกขั้นตอน",
  "keywords": [
   "ทนายธนาคาร Banking Lawyer",
   "ฟ้องลูกหนี้ NPL Non-Performing Loan",
   "ปรับโครงสร้างหนี้ Debt Restructuring",
   "Business Rehabilitation ฟื้นฟูกิจการ",
   "Securities Law กฎหมายหลักทรัพย์",
   "SEC Compliance ก.ล.ต.",
   "IPO ตลาดหลักทรัพย์",
   "Fintech License",
   "Crypto Digital Asset License",
   "Insider Trading ปั่นหุ้น",
   "Anti-Money Laundering AML ปปง.",
   "Project Finance + Syndicated Loan"
  ],
  "priceFrom": 12000,
  "priceTo": 8500000,
  "turnaround": "1–365 วัน (ปรึกษา 1 วัน · NPL Suit 30 วัน · Restructuring 90-180 วัน · IPO 12-18 เดือน)",
  "coverage": "ศาลแพ่ง/ศาลล้มละลายกลาง · ก.ล.ต. (SEC) · ธปท. (BOT) · ตลท. (SET) · DSI · ปปง.",
  "languagesCount": 16,
  "relatedServiceIds": [
   "company-boi",
   "tax-law",
   "real-estate-conveyancing",
   "civil-family-probate"
  ],
  "faqCount": 12
 },
 "pdpa-cybersecurity": {
  "id": "pdpa-cybersecurity",
  "slug": "pdpa-cybersecurity",
  "nameTh": "PDPA · Cybersecurity · กฎหมายคุ้มครองข้อมูลส่วนบุคคล",
  "nameEn": "PDPA & Cybersecurity Law · Data Protection · Cyber Incident Response",
  "shortTh": "PDPA Compliance · DPO · DPIA · Cyber Incident Response · GDPR · ISO 27001",
  "taglineTh": "ที่ปรึกษา PDPA · Cybersecurity ครบวงจร — DPO Outsourced · DPIA · Data Breach Response · GDPR Cross-border · ISO 27001 · NIST",
  "taglineEn": "Full-service PDPA & Cybersecurity counsel — DPO · DPIA · Breach Response · GDPR · ISO 27001 · NIST CSF",
  "metaTitle": "ที่ปรึกษา PDPA DPO Cybersecurity Data Breach GDPR ISO 27001 | NYC Legal",
  "metaDesc": "ทีม PDPA & Cybersecurity 18+ คน — DPO Outsourced · DPIA · Records of Processing · Data Breach 72 ชม. · GDPR Cr — ส่งภาพเอกสารมาเช็กให้ก่อน ฟรี ไม่คิดค่าปรึกษา",
  "keywords": [
   "PDPA ที่ปรึกษากฎหมาย",
   "DPO Outsourced Data Protection Officer",
   "DPIA Data Protection Impact Assessment",
   "Data Breach Response 72 ชั่วโมง",
   "GDPR Cross-border Compliance",
   "ISO 27001 Cybersecurity",
   "NIST Cybersecurity Framework",
   "Cyber Incident Response",
   "Ransomware Negotiation",
   "Cookie Consent CMP",
   "Records of Processing Activities ROPA",
   "Data Transfer Agreement SCC BCR"
  ],
  "priceFrom": 9500,
  "priceTo": 3500000,
  "turnaround": "1–180 วัน (ปรึกษา 1 วัน · Gap Assessment 7-14 วัน · Full Implementation 60-180 วัน · Breach Response 4 ชม.)",
  "coverage": "สคส. (PDPC) · สกมช. (NCSA) · ETDA · กสทช. · ธปท. · ก.ล.ต. · ICO (UK) · CNIL (FR) · EDPB",
  "languagesCount": 14,
  "relatedServiceIds": [
   "company-boi",
   "banking-finance",
   "trademark-ip",
   "criminal-defense"
  ],
  "faqCount": 12
 },
 "international-arbitration": {
  "id": "international-arbitration",
  "slug": "international-arbitration",
  "nameTh": "อนุญาโตตุลาการระหว่างประเทศ · International Arbitration · Cross-border Dispute",
  "nameEn": "International Arbitration & Cross-border Dispute Resolution",
  "shortTh": "TAI · THAC · SIAC · HKIAC · ICC · UNCITRAL · Investor-State · Enforcement of Awards",
  "taglineTh": "ทนายอนุญาโตตุลาการระหว่างประเทศครบวงจร — TAI · THAC · SIAC · HKIAC · ICC · LCIA · UNCITRAL · ICSID · Enforcement New York Convention 1958",
  "taglineEn": "Full-service International Arbitration & Cross-border Disputes — TAI · THAC · SIAC · HKIAC · ICC · LCIA · UNCITRAL · ICSID · NY Convention Enforcement",
  "metaTitle": "ทนายอนุญาโตตุลาการระหว่างประเทศ TAI THAC SIAC HKIAC ICC ICSID | NYC Legal",
  "metaDesc": "ทีม International Arbitration 14+ คน · FCIArb/MCIArb · ว่าความ TAI · THAC · SIAC · HKIAC · ICC · LCIA · UNC — คุยกับผู้เชี่ยวชาญตัวจริง ตอบกลับภายในไม่กี่นาที",
  "keywords": [
   "ทนายอนุญาโตตุลาการระหว่างประเทศ",
   "International Arbitration Lawyer Thailand",
   "TAI สถาบันอนุญาโตตุลาการ",
   "THAC Thailand Arbitration Center",
   "SIAC Singapore Arbitration",
   "HKIAC Hong Kong Arbitration",
   "ICC International Chamber of Commerce",
   "LCIA London Court of International Arbitration",
   "UNCITRAL Model Law Arbitration",
   "ICSID Investor-State Arbitration",
   "Enforcement New York Convention 1958",
   "Cross-border Dispute Resolution"
  ],
  "priceFrom": 85000,
  "priceTo": 12000000,
  "turnaround": "30 วัน – 36 เดือน (Emergency Arbitrator 15 วัน · Expedited 6 เดือน · Full Arbitration 12-24 เดือน · ICSID 24-48 เดือน)",
  "coverage": "TAI · THAC · SIAC · HKIAC · ICC · LCIA · SCC · DIAC · KLRCA/AIAC · JCAA · CIETAC · ICSID · PCA · UNCITRAL Ad-hoc",
  "languagesCount": 14,
  "relatedServiceIds": [
   "banking-finance",
   "company-boi",
   "labor-employment",
   "civil-family-probate"
  ],
  "faqCount": 11
 },
 "ltr-elite-visa": {
  "id": "ltr-elite-visa",
  "slug": "ltr-elite-visa",
  "nameTh": "LTR Visa · Thailand Privilege (Elite) · BOI Smart Visa · Immigration ครบวงจร",
  "nameEn": "LTR Visa, Thailand Privilege (Elite), BOI Smart Visa & Immigration",
  "shortTh": "วีซ่าผู้พำนักระยะยาว LTR/Elite/Smart Visa + Work Permit + PR + สัญชาติ",
  "taglineTh": "ทีม Immigration เฉพาะทาง 12+ คน — LTR Visa 10 ปี (BOI) · Thailand Privilege (Elite) 5-20 ปี · BOI Smart Visa (4 ประเภท) · Work Permit · Permanent Residence · สัญชาติไทย — Approval Rate 96% · 1,850+ เคส · ตัวแทนที่ได้รับการรับรอง BOI + Thailand Privilege Card Co., Ltd.",
  "taglineEn": "Dedicated Immigration team — LTR Visa, Elite, Smart Visa, Work Permit, PR & Citizenship.",
  "metaTitle": "LTR Visa · Elite Visa · BOI Smart Visa · Immigration ครบวงจร — Approval 96% | NYC Legal",
  "metaDesc": "บริการ LTR Visa 10 ปี · Thailand Privilege (Elite) · BOI Smart Visa · Work Permit · Permanent Residence · สัญชาติ · Tax Optimization 17% — ทีม 12+ คน · 1,850+ เคส · Approval 96%",
  "keywords": [
   "LTR Visa 10 ปี Long-Term Resident",
   "Thailand Privilege Visa Elite",
   "BOI Smart Visa T S I E O",
   "Work Permit ใบอนุญาตทำงาน",
   "Permanent Residence ใบสำคัญถิ่นที่อยู่",
   "Thai Citizenship สัญชาติไทย",
   "Investor Visa Investment Visa",
   "Digital Nomad Visa DTV Destination Thailand",
   "Retirement Visa Non-O-A",
   "Marriage Visa Non-O",
   "Education Visa Non-ED",
   "Tax Resident 17% Flat Tax LTR"
  ],
  "priceFrom": 18000,
  "priceTo": 4500000,
  "turnaround": "LTR 60-90 วัน · Elite 30-45 วัน · Smart Visa 30-60 วัน · PR 12-36 เดือน",
  "coverage": "127 จุด · 77 จังหวัด · สำนักงานตรวจคนเข้าเมือง 88 ด่าน + BOI + Thailand Privilege",
  "languagesCount": 50,
  "relatedServiceIds": [
   "visa-foreigners-thailand",
   "work-permit-boi",
   "permanent-residence",
   "thai-citizenship"
  ],
  "faqCount": 12
 },
 "ma-private-equity": {
  "id": "ma-private-equity",
  "slug": "ma-private-equity",
  "nameTh": "M&A · Private Equity · Venture Capital · Corporate Finance ครบวงจร",
  "nameEn": "M&A, Private Equity, Venture Capital & Corporate Finance",
  "shortTh": "ที่ปรึกษา M&A/PE/VC ตั้งแต่ Term Sheet · DD · SPA/SHA · ESOP · Exit",
  "taglineTh": "ทีม Corporate M&A เฉพาะทาง 18+ คน — Term Sheet · Legal Due Diligence · SPA/APA/SHA · ESOP · Carve-out · LBO · Roll-up · Cross-border Deal · Exit (Trade Sale/IPO/Secondary) — ปิดดีล 215+ Transactions · มูลค่ารวม ฿285,000M+ · Cross-border 18 ประเทศ",
  "taglineEn": "Full-service M&A, PE, VC & Corporate Finance advisory — Term Sheet to Exit.",
  "metaTitle": "M&A · Private Equity · VC · Corporate Finance — ปิดดีล 215+ Transactions | NYC Legal",
  "metaDesc": "ที่ปรึกษา M&A · PE · VC · Term Sheet · Legal DD · SPA · SHA · ESOP · Carve-out · LBO · Roll-up · Cross-borde — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที",
  "keywords": [
   "M&A Mergers Acquisitions ที่ปรึกษากฎหมาย",
   "Private Equity PE Fund Counsel",
   "Venture Capital VC Term Sheet SAFE",
   "Legal Due Diligence VDR DD",
   "SPA Share Purchase Agreement APA",
   "SHA Shareholders Agreement ROFR Tag-along Drag-along",
   "ESOP Employee Stock Option Plan",
   "Carve-out Spin-off Divestiture",
   "Leveraged Buyout LBO Acquisition Financing",
   "Cross-border M&A Foreign Investment FBA",
   "Exit Strategy Trade Sale IPO Secondary Sale",
   "Earn-out Escrow Working Capital Adjustment"
  ],
  "priceFrom": 35000,
  "priceTo": 12000000,
  "turnaround": "Term Sheet 7-14 วัน · DD 4-8 สัปดาห์ · Signing-to-Closing 8-24 สัปดาห์",
  "coverage": "Cross-border 18 ประเทศ · SET/mai · ก.ล.ต. · BOI · DBD · TCC",
  "languagesCount": 50,
  "relatedServiceIds": [
   "banking-finance",
   "tax-law",
   "international-arbitration",
   "company-boi",
   "trademark-ip",
   "pdpa-cybersecurity"
  ],
  "faqCount": 12
 },
 "work-experience-certificate": {
  "id": "work-experience-certificate",
  "slug": "work-experience-certificate",
  "nameTh": "บริการขอใบรับรองประสบการณ์ทำงาน (ประกันสังคม · กระทรวงแรงงาน · แปล · กงสุล · สถานทูต)",
  "nameEn": "Work Experience Certificate Service — SSO, Ministry of Labour, Translation & Legalization",
  "shortTh": "ขอใบรับรองประสบการณ์ทำงาน สปส. + แปล + กงสุล + สถานทูต ครบในที่เดียว",
  "taglineTh": "บริการขอหนังสือรับรองประวัติการทำงานจากสำนักงานประกันสังคม (สปส.6-09) และกระทรวงแรงงาน พร้อมแปลภาษาอังกฤษและภาษาอื่น ๆ รับรองคำแปลโดยกรมการกงสุล (MFA) และสถานทูตประเทศปลายทาง — ใช้ยื่นวีซ่าทักษะ/วีซ่าทำงาน/Skilled Migration ได้ทันที",
  "taglineEn": "End-to-end work experience certificate service: obtain official records from Social Security Office (SSO Form 6-09) and Ministry of Labour, translate into English/Chinese/Japanese/German, then legalize at the Thai MFA and destination embassy — accepted by Skilled Migration, points-based visas, and overseas professional licensing bodies.",
  "metaTitle": "ขอใบรับรองประสบการณ์ทำงาน สปส. + แปล + กงสุล + สถานทูต | NYC Legal",
  "metaDesc": "บริการขอใบรับรองประสบการณ์ทำงานจากประกันสังคม กระทรวงแรงงาน พร้อมแปล + รับรองกงสุล MFA + สถานทูต ใช้ยื่นวีซ่า — ส่งภาพเอกสารมาเช็กให้ก่อน ฟรี ไม่คิดค่าปรึกษา083-249-4999",
  "keywords": [
   "ใบรับรองประสบการณ์ทำงาน",
   "หนังสือรับรองการทำงานประกันสังคม",
   "สปส.6-09",
   "Work Experience Certificate Thailand",
   "Employment Verification Letter Thailand",
   "ใบรับรองนายจ้าง แปลภาษาอังกฤษ",
   "Skilled Migration Thailand",
   "รับรองประวัติทำงานยื่นวีซ่า",
   "Ministry of Labour Thailand Certificate",
   "ขอใบรับรองทำงานยื่นออสเตรเลีย"
  ],
  "priceFrom": 2500,
  "priceTo": 25000,
  "turnaround": "เร่งด่วน 3 วัน · มาตรฐาน 7–14 วันทำการ",
  "coverage": "ทั่วประเทศไทย + จัดส่งทั่วโลก",
  "languagesCount": 50,
  "relatedServiceIds": [
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "notary-public",
   "visa-thai-citizens",
   "apec-abtc"
  ],
  "faqCount": 12
 },
 "medical-council-certification": {
  "id": "medical-council-certification",
  "slug": "medical-council-certification",
  "nameTh": "บริการรับรองเอกสารโดยแพทยสภา (Good Standing · ใบประกอบวิชาชีพ · Specialist Certificate)",
  "nameEn": "Medical Council Certification Service — Good Standing, Medical License & Specialist Verification",
  "shortTh": "รับรองแพทยสภา + แปล + Notary + กงสุล + สถานทูต ครบในที่เดียว",
  "taglineTh": "บริการรับรอง Good Standing Certificate และใบประกอบวิชาชีพแพทย์ ทันตแพทย์ เภสัชกร พยาบาล กายภาพบำบัด จากแพทยสภาและสภาวิชาชีพที่เกี่ยวข้อง พร้อมแปล + Notary + รับรองกงสุล MFA + สถานทูต สำหรับสมัครงาน สอบ Board หรือขอใบประกอบวิชาชีพในต่างประเทศ",
  "taglineEn": "End-to-end medical professional credentialing: obtain Good Standing Certificate from the Medical Council of Thailand, Dental Council, Pharmacy Council, Nursing Council, or Physical Therapy Council, then translate, notarize, and legalize at the MFA and destination embassy — ready for USMLE, PLAB, AMC, MCQ, or foreign medical license application.",
  "metaTitle": "รับรองแพทยสภา + แปล + กงสุล + สถานทูต ใบประกอบวิชาชีพแพทย์ | NYC Legal",
  "metaDesc": "บริการรับรอง Good Standing Certificate แพทยสภา ทันตแพทยสภา สภาเภสัชฯ พยาบาล + แปล + Notary + MFA + สถานทูต ใช้ — ส่งภาพเอกสารมาเช็กให้ก่อน ฟรี ไม่คิดค่าปรึกษา083-249-4999",
  "keywords": [
   "รับรองแพทยสภา",
   "Good Standing Certificate แพทยสภา",
   "ใบประกอบวิชาชีพแพทย์ แปล",
   "Medical License Verification Thailand",
   "Thailand Medical Council Certificate",
   "รับรองทันตแพทยสภา",
   "รับรองสภาเภสัชกรรม",
   "รับรองสภาการพยาบาล",
   "USMLE Thailand Documents",
   "PLAB Thailand Documents",
   "AMC Verification Thailand",
   "Medical Specialist Certificate Translation"
  ],
  "priceFrom": 4500,
  "priceTo": 35000,
  "turnaround": "เร่งด่วน 5 วัน · มาตรฐาน 14–21 วันทำการ",
  "coverage": "ทั่วประเทศไทย + จัดส่งทั่วโลก",
  "languagesCount": 50,
  "relatedServiceIds": [
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "notary-public",
   "sworn-translation",
   "naati"
  ],
  "faqCount": 12
 },
 "notary-public-foreigners": {
  "id": "notary-public-foreigners",
  "slug": "notary-public-foreigners",
  "nameTh": "Notary Public บริการรับรองเอกสารสำหรับชาวต่างชาติในประเทศไทย",
  "nameEn": "Notary Public Service for Foreigners in Thailand — English-Speaking Notarial Services Attorney",
  "shortTh": "Notary Public English service for expats — POA, affidavits, signature witnessing, certified copies",
  "taglineTh": "Notary Public ภาษาอังกฤษสำหรับชาวต่างชาติในไทย — รับรองหนังสือมอบอำนาจ (POA), Affidavit, Statutory Declaration, Signature Witnessing, Certified Copy, รับรองเอกสารการเงิน/อสังหาฯ พร้อมแปลและรับรองกงสุล MFA/สถานทูตในแพ็กเกจเดียว ทนายความผู้ทำคำรับรองลายมือชื่อ (Notarial Services Attorney) ขึ้นทะเบียนสภาทนายความฯ ให้บริการเป็นภาษาอังกฤษทุกขั้นตอน",
  "taglineEn": "English-speaking Notary Public service for expats and foreign nationals in Thailand. Powers of Attorney, affidavits, statutory declarations, signature witnessing, certified true copies, real-estate and financial-document notarisation — bundled with translation, MFA legalisation, and embassy authentication. Our Notarial Services Attorneys are registered with the Lawyers Council of Thailand and conduct the entire process in English.",
  "metaTitle": "Notary Public Bangkok — English-Speaking Notarial Services for Foreigners | NYC Legal",
  "metaDesc": "English Notary Public in Bangkok for expats: POA, affidavit, signature witness, certified copies + MFA + embassy. — ทีมงานตอบไวทุกวัน ปรึกษาก่อนตัดสินใจได้ฟรี083-249-4999",
  "keywords": [
   "Notary Public Bangkok",
   "Notary Public Thailand for foreigners",
   "English Notary Bangkok",
   "Notarial Services Attorney Thailand",
   "Power of Attorney Thailand",
   "Affidavit Bangkok",
   "Statutory Declaration Thailand",
   "Signature Witnessing Bangkok",
   "Certified True Copy Thailand",
   "Notary near me Bangkok",
   "Apostille Notary Thailand",
   "Expat Notary Thailand"
  ],
  "priceFrom": 1500,
  "priceTo": 25000,
  "turnaround": "Same-day · 1–3 business days (with legalisation)",
  "coverage": "Bangkok, Pattaya, Phuket, Chiang Mai · Mobile service nationwide",
  "languagesCount": 50,
  "relatedServiceIds": [
   "notary-public",
   "mfa-legalization-foreigners",
   "translation",
   "embassy-legalization",
   "marriage-thai-foreign",
   "real-estate-conveyancing"
  ],
  "faqCount": 12
 },
 "mfa-legalization-foreigners": {
  "id": "mfa-legalization-foreigners",
  "slug": "mfa-legalization-foreigners",
  "nameTh": "MFA Legalisation Service for Foreigners — Thai Consular Authentication (English Service)",
  "nameEn": "MFA / Consular Legalisation Service for Foreigners in Thailand",
  "shortTh": "End-to-end MFA + embassy legalisation in English for expats and foreign nationals",
  "taglineTh": "บริการรับรองนิติกรณ์กรมการกงสุล (MFA) และสถานทูตประเทศปลายทาง สำหรับชาวต่างชาติในไทย — รองรับเอกสารส่วนตัวและองค์กร เช่น Birth/Marriage/Death Certificate, Police Clearance, Academic Records, Company Documents — ดำเนินการในภาษาอังกฤษทุกขั้นตอน รับ-ส่งเอกสารถึงโรงแรม/ออฟฟิศ และจัดส่ง DHL ทั่วโลก",
  "taglineEn": "End-to-end Thai MFA (Department of Consular Affairs) legalisation and destination-embassy authentication for foreign nationals in Thailand. We handle Thai birth/marriage/death certificates, police-clearance certificates, academic transcripts, company documents, and bilingual translations — in English from quote to delivery — and ship worldwide via DHL / FedEx.",
  "metaTitle": "MFA Legalisation Bangkok for Foreigners — Consular Authentication | NYC Legal",
  "metaDesc": "English-language MFA & embassy legalisation service in Bangkok for expats. Birth, marriage, police, academic, com — ปรึกษาฟรี ประเมินงานให้ทันที ทักไลน์ได้เลย083-249-4999",
  "keywords": [
   "MFA legalisation Bangkok",
   "Thai consular legalisation English",
   "Department of Consular Affairs Thailand",
   "Apostille Thailand for foreigners",
   "Legalise Thai marriage certificate",
   "Legalise Thai birth certificate",
   "Authenticate Thai police clearance",
   "Embassy legalisation Bangkok",
   "Thai document legalisation for use abroad"
  ],
  "priceFrom": 3500,
  "priceTo": 35000,
  "turnaround": "Express 2 days · Standard 5–10 business days",
  "coverage": "Thailand-wide pickup · Worldwide DHL/FedEx delivery",
  "languagesCount": 50,
  "relatedServiceIds": [
   "mfa-legalization",
   "notary-public-foreigners",
   "translation",
   "embassy-legalization",
   "embassy-legalization-by-country",
   "police-clearance"
  ],
  "faqCount": 12
 },
 "marriage-abroad-thai": {
  "id": "marriage-abroad-thai",
  "slug": "marriage-abroad-thai",
  "nameTh": "บริการจดทะเบียนสมรสในต่างประเทศสำหรับคนไทย (USA, UK, Australia, Germany, Japan, China และอีก 40+ ประเทศ)",
  "nameEn": "Marriage Abroad — Document & Legalisation Service for Thai Citizens (40+ Countries)",
  "shortTh": "เตรียมเอกสารคนไทยจดทะเบียนสมรสในต่างประเทศ ครบทุกขั้นตอน + แปล + MFA + สถานทูต",
  "taglineTh": "บริการครบวงจรสำหรับคนไทยที่จะจดทะเบียนสมรสในต่างประเทศ — ขอใบรับรองโสด (Single Status Certificate) จากเขต/อำเภอ + แปลภาษาประเทศปลายทาง + รับรอง MFA + รับรองสถานทูต + คำแนะนำขั้นตอนจดทะเบียนของแต่ละประเทศ (สหรัฐฯ, อังกฤษ, ออสเตรเลีย, นิวซีแลนด์, แคนาดา, เยอรมัน, ฝรั่งเศส, เนเธอร์แลนด์, สวีเดน, นอร์เวย์, เดนมาร์ก, สวิตเซอร์แลนด์, ญี่ปุ่น, จีน, ไต้หวัน, ฮ่องกง, สิงคโปร์, มาเลเซีย, สหรัฐอาหรับเอมิเรตส์ และอีก 40+ ประเทศ) — พร้อมบริการ Affirmation/Affidavit หากประเทศปลายทางต้องการ",
  "taglineEn": "End-to-end document service for Thai citizens marrying abroad — Single Status Certificate, certified translation in the destination language, MFA legalisation, embassy authentication, and country-specific guidance for the marriage registration itself in the USA, UK, EU, Nordics, Australia, NZ, Canada, Japan, China, Taiwan, HK, Singapore, UAE, and 40+ other jurisdictions.",
  "metaTitle": "จดทะเบียนสมรสต่างประเทศ คนไทย — Single Status + แปล + MFA + สถานทูต | NYC Legal",
  "metaDesc": "บริการครบวงจรคนไทยจดทะเบียนสมรสต่างประเทศ ใบรับรองโสด + แปล + MFA + สถานทูต 40+ ประเทศ (USA UK ออสเตรเลีย เย — เริ่มต้นง่าย ๆ แค่ทักไลน์ เราดูแลจนจบทุกขั้นตอน083-249-4999",
  "keywords": [
   "จดทะเบียนสมรสต่างประเทศ",
   "Single Status Certificate Thailand",
   "ใบรับรองโสด แปล",
   "Affirmation of Marital Status Thailand",
   "Thai marriage USA",
   "Thai marriage UK",
   "Thai marriage Germany",
   "Thai marriage Australia",
   "Thai marriage Japan",
   "Nulla Osta Italy Thailand",
   "Ehefähigkeitszeugnis Thailand",
   "Marriage registration overseas Thai citizen"
  ],
  "priceFrom": 6500,
  "priceTo": 45000,
  "turnaround": "Express 7 days · Standard 14–21 business days",
  "coverage": "ทั่วประเทศไทย + ส่งเอกสารถึงต่างประเทศ",
  "languagesCount": 50,
  "relatedServiceIds": [
   "marriage-thai-foreign",
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "visa-thai-citizens",
   "notary-public"
  ],
  "faqCount": 12
 },
 "naati-online-worldwide": {
  "id": "naati-online-worldwide",
  "slug": "naati-online-worldwide",
  "nameTh": "NAATI Certified Translation บริการแปล NAATI ออนไลน์ทั่วโลก (Australia, NZ, Worldwide)",
  "nameEn": "NAATI Certified Translation Online — Worldwide Service",
  "shortTh": "บริการ NAATI Certified Translator ออนไลน์ ส่งงานทั่วโลก ใช้ยื่นวีซ่าออสเตรเลีย/นิวซีแลนด์",
  "taglineTh": "บริการ NAATI Certified Translation (Thai ↔ English) แบบออนไลน์เต็มรูปแบบ — รับเอกสารทาง email/LINE/WhatsApp ส่งงานแปลพร้อมตราประทับ NAATI ดิจิทัล (NAATI Digital Stamp) ใช้ยื่น Department of Home Affairs ออสเตรเลีย, Immigration NZ, AHPRA, NAATI for VEVO และทุกหน่วยงานในออสเตรเลีย/นิวซีแลนด์ ลูกค้าอยู่ในประเทศไหนก็ใช้ได้ — รับงาน 24/7 ส่งภายใน 24–48 ชั่วโมง",
  "taglineEn": "Online NAATI Certified Translation (Thai ↔ English) for clients worldwide. Upload your document, receive a fully NAATI-certified PDF with digital stamp within 24–48 hours — accepted by the Australian Department of Home Affairs, Immigration NZ, AHPRA, VEVO, and every Australian and New Zealand government agency. Used by 12,000+ migrants, students, and professionals each year.",
  "metaTitle": "NAATI Translation Online Worldwide — Thai ↔ English in 24h | NYC Legal",
  "metaDesc": "Online NAATI Certified Translation Thai↔English worldwide. Digital stamp, accepted by Australian Home Affairs, Im — ปรึกษาฟรี ประเมินงานให้ทันที ทักไลน์ได้เลย083-249-4999",
  "keywords": [
   "NAATI Certified Translation Online",
   "NAATI Thai English translation worldwide",
   "NAATI digital stamp",
   "NAATI translator Thailand",
   "Australian visa translation Thai",
   "Immigration NZ translation Thai",
   "AHPRA NAATI translation",
   "Skilled Migration translation NAATI",
   "Partner visa translation Thai",
   "NAATI Sydney Melbourne Brisbane Perth"
  ],
  "priceFrom": 850,
  "priceTo": 15000,
  "turnaround": "Standard 24–48h · Express 6–12h",
  "coverage": "Worldwide online — clients in 60+ countries",
  "languagesCount": 2,
  "relatedServiceIds": [
   "naati",
   "translation",
   "sworn-translation",
   "visa-thai-citizens",
   "work-experience-certificate",
   "medical-council-certification"
  ],
  "faqCount": 12
 },
 "government-document-translation": {
  "id": "government-document-translation",
  "slug": "government-document-translation",
  "nameTh": "บริการแปลเอกสารราชการไทย ครบทุกประเภท (ทะเบียนราษฎร์ · ทะเบียนบ้าน · โฉนด · ทะเบียนบริษัท · คำพิพากษา)",
  "nameEn": "Thai Government Document Translation Service — Civil Registry, Property, Corporate, Court",
  "shortTh": "แปลเอกสารราชการไทยทุกประเภทโดยนักแปลขึ้นทะเบียนกรมการกงสุล + รับรองคำแปลพร้อมใช้",
  "taglineTh": "บริการแปลเอกสารราชการไทยทุกประเภท: บัตรประชาชน, ทะเบียนบ้าน, สูติบัตร, มรณบัตร, ใบเปลี่ยนชื่อ-นามสกุล, ใบรับรองโสด, ทะเบียนสมรส/หย่า, โฉนดที่ดิน, นส.3, สัญญาเช่า, หนังสือรับรองบริษัท, บอจ.5, ใบทะเบียนพาณิชย์, ใบทะเบียนภาษีมูลค่าเพิ่ม, คำพิพากษา, คำสั่งศาล, ใบแต่งทนาย — แปลโดยนักแปลและบริษัทที่ขึ้นทะเบียนกรมการกงสุล MFA พร้อมรับรองคำแปล ใช้ยื่นได้ทันทีทุกหน่วยงานในและต่างประเทศ",
  "taglineEn": "Full-spectrum Thai government document translation: civil registry, household registration, property titles, corporate filings, court orders. Translators registered with the Thai MFA. Includes translator's certification and company seal — ready for direct submission to immigration, embassies, courts, universities, and corporate counterparties.",
  "metaTitle": "แปลเอกสารราชการไทย รับรองกงสุล MFA ครบทุกประเภท | NYC Legal",
  "metaDesc": "แปลเอกสารราชการไทย: ทะเบียนบ้าน บัตร ปชช. สูติบัตร โฉนด ทะเบียนบริษัท คำพิพากษา โดยนักแปลขึ้นทะเบียน MFA พร้อมรับ — ทีมงานตอบไวทุกวัน ปรึกษาก่อนตัดสินใจได้ฟรี083-249-4999",
  "keywords": [
   "แปลเอกสารราชการ",
   "แปลทะเบียนบ้าน",
   "แปลบัตรประชาชน",
   "แปลสูติบัตร",
   "แปลทะเบียนสมรส",
   "แปลโฉนดที่ดิน",
   "แปลหนังสือรับรองบริษัท",
   "แปลคำพิพากษา",
   "Thai civil registry translation",
   "Land title translation Thailand",
   "Company affidavit translation Thailand",
   "Sworn translation Thailand government"
  ],
  "priceFrom": 500,
  "priceTo": 25000,
  "turnaround": "เร่งด่วน 1 วัน · มาตรฐาน 1–3 วันทำการ",
  "coverage": "ทั่วประเทศไทย + ส่งทั่วโลก",
  "languagesCount": 50,
  "relatedServiceIds": [
   "translation",
   "sworn-translation",
   "government-document-certification",
   "mfa-legalization",
   "notary-public",
   "embassy-legalization"
  ],
  "faqCount": 12
 },
 "government-document-certification": {
  "id": "government-document-certification",
  "slug": "government-document-certification",
  "nameTh": "บริการขอและรับรองเอกสารราชการไทย (ทะเบียนราษฎร์ · กรมที่ดิน · DBD · ศาล)",
  "nameEn": "Thai Government Document Procurement & Certification Service",
  "shortTh": "บริการขอสำเนาเอกสารราชการ + รับรองสำเนาถูกต้องจากต้นสังกัด พร้อมแปลและส่งทั่วโลก",
  "taglineTh": "บริการขอและรับรองเอกสารราชการไทยทุกหน่วยงาน — ขอสำเนาสูติบัตร/มรณบัตร/ทะเบียนสมรส/หย่า/ใบเปลี่ยนชื่อจากเขต/อำเภอ, ขอใบรับรองโสดและรับรองสถานะครอบครัวจากกรมการปกครอง, ขอสำเนาโฉนดและสารบบที่ดินจากกรมที่ดิน, ขอหนังสือรับรองบริษัทและบอจ.5 จาก DBD, ขอสำเนาคำพิพากษาจากศาล — รับรองสำเนาถูกต้องจากต้นสังกัด พร้อมแปลและส่งถึงปลายทางทั่วโลก",
  "taglineEn": "We obtain and certify true copies of Thai government documents from the source authority: civil registry (district / amphur office), Department of Provincial Administration (Single Status Certificate, family status), Department of Lands (title deeds, transfer history), DBD (company affidavit, BOJ-5), Courts (judgements, case files). Bundled with translation, MFA, and embassy legalisation, then shipped worldwide.",
  "metaTitle": "ขอเอกสารราชการ + รับรองสำเนา ทะเบียนราษฎร์ ที่ดิน DBD ศาล | NYC Legal",
  "metaDesc": "บริการขอและรับรองสำเนาเอกสารราชการไทยทุกหน่วยงาน เขต/อำเภอ · กรมที่ดิน · DBD · ศาล · กระทรวงต่าง ๆ พร้อมแปล + MFA — ปรึกษาฟรีก่อนยื่นจริง ลดโอกาสเอกสารตีกลับ083-249-4999",
  "keywords": [
   "ขอเอกสารราชการ",
   "ขอสำเนาสูติบัตร",
   "ขอใบรับรองโสด",
   "ขอสำเนาทะเบียนสมรส",
   "ขอสำเนาโฉนดที่ดิน",
   "ขอหนังสือรับรองบริษัท DBD",
   "ขอสำเนาคำพิพากษา",
   "รับรองสำเนาถูกต้องเขต",
   "Thai government document procurement",
   "Thai civil registry copy",
   "Land Department title deed copy Thailand"
  ],
  "priceFrom": 2500,
  "priceTo": 35000,
  "turnaround": "เร่งด่วน 1–3 วัน · มาตรฐาน 5–10 วันทำการ",
  "coverage": "ทั่วประเทศไทย — มอบอำนาจขอเอกสารทุกจังหวัด",
  "languagesCount": 50,
  "relatedServiceIds": [
   "government-document-translation",
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "notary-public",
   "marriage-abroad-thai"
  ],
  "faqCount": 12
 },
 "embassy-legalization-by-country": {
  "id": "embassy-legalization-by-country",
  "slug": "embassy-legalization-by-country",
  "nameTh": "บริการรับรองเอกสารโดยสถานทูต 30+ ประเทศในกรุงเทพฯ (USA, UK, EU, GCC, Asia)",
  "nameEn": "Embassy Legalisation Service — 30+ Embassies in Bangkok",
  "shortTh": "Hub กลางสำหรับรับรองสถานทูตทุกประเทศในกรุงเทพฯ พร้อมข้อมูล SLA และค่าธรรมเนียม",
  "taglineTh": "บริการรับรองนิติกรณ์สถานทูตในกรุงเทพฯ ครอบคลุม 30+ ประเทศ — สหรัฐฯ, อังกฤษ, ออสเตรเลีย, นิวซีแลนด์, แคนาดา, เยอรมัน, ฝรั่งเศส, อิตาลี, สเปน, เนเธอร์แลนด์, สวีเดน, นอร์เวย์, เดนมาร์ก, สวิตเซอร์แลนด์, ญี่ปุ่น, เกาหลีใต้, จีน, ฮ่องกง, ไต้หวัน, สิงคโปร์, มาเลเซีย, อินโดนีเซีย, เวียดนาม, อินเดีย, UAE, ซาอุดิอาระเบีย, กาตาร์, คูเวต, โอมาน, อิสราเอล, รัสเซีย, ตุรกี และอีกหลายประเทศ — แสดง SLA, ค่าธรรมเนียม, ชั่วโมงทำการล่าสุด, และข้อกำหนดเอกสารของแต่ละสถานทูต",
  "taglineEn": "Single-source embassy legalisation in Bangkok covering 30+ embassies and consulates — USA, UK, EU, Nordics, GCC, Asia. We monitor each embassy's published SLA, fee schedule, opening hours, and document specification weekly, so you always submit with the correct paperwork the first time.",
  "metaTitle": "รับรองสถานทูต 30+ ประเทศ กรุงเทพฯ (USA UK EU GCC Asia) | NYC Legal",
  "metaDesc": "บริการรับรองสถานทูตในกรุงเทพฯ 30+ ประเทศ ครบทุกประเทศที่นิยม (USA UK เยอรมัน ญี่ปุ่น UAE) พร้อม SLA + ค่าธรรมเนียม — ปรึกษาฟรีก่อนยื่นจริง ลดโอกาสเอกสารตีกลับ083-249-4999",
  "keywords": [
   "รับรองสถานทูต",
   "Embassy legalisation Bangkok",
   "US Embassy authentication Thailand",
   "British Embassy legalisation Bangkok",
   "German Embassy legalisation Thailand",
   "Australian Embassy legalisation",
   "Japan Embassy Bangkok legalisation",
   "UAE Embassy Bangkok",
   "Saudi Embassy Bangkok legalisation",
   "Consular legalisation by country",
   "Embassy attestation Bangkok"
  ],
  "priceFrom": 5000,
  "priceTo": 35000,
  "turnaround": "5–15 business days (depends on embassy)",
  "coverage": "Bangkok embassies + consulates worldwide via partner network",
  "languagesCount": 50,
  "relatedServiceIds": [
   "embassy-legalization",
   "mfa-legalization",
   "mfa-legalization-foreigners",
   "translation",
   "marriage-abroad-thai",
   "notary-public-foreigners"
  ],
  "faqCount": 12
 }
} as unknown as Record<ServiceId, ServiceHeadMeta>;

const ALIASES: Record<string, string> = {
 "translation": "translation",
 "notary-public": "notary-public",
 "naati": "naati",
 "police-clearance": "police-clearance",
 "mfa-legalization": "mfa-legalization",
 "embassy-legalization": "embassy-legalization",
 "visa-thai-citizens": "visa-thai-citizens",
 "visa-foreigners-thailand": "visa-foreigners-thailand",
 "marriage-thai-foreign": "marriage-thai-foreign",
 "interpreter": "interpreter",
 "apec-business-travel-card": "apec-abtc",
 "apec-abtc": "apec-abtc",
 "apostille": "apostille",
 "tm30-90day-report": "tm30-90day",
 "tm30-90day": "tm30-90day",
 "work-permit-boi-single-window": "work-permit-boi",
 "work-permit-boi": "work-permit-boi",
 "permanent-residence-thailand": "permanent-residence",
 "permanent-residence": "permanent-residence",
 "thai-citizenship": "thai-citizenship",
 "company-boi": "company-boi",
 "trademark-ip": "trademark-ip",
 "sworn-translation": "sworn-translation",
 "criminal-defense": "criminal-defense",
 "civil-family-probate": "civil-family-probate",
 "real-estate-conveyancing": "real-estate-conveyancing",
 "tax-law": "tax-law",
 "labor-employment": "labor-employment",
 "banking-finance": "banking-finance",
 "pdpa-cybersecurity": "pdpa-cybersecurity",
 "international-arbitration": "international-arbitration",
 "ltr-elite-visa": "ltr-elite-visa",
 "ma-private-equity": "ma-private-equity",
 "work-experience-certificate": "work-experience-certificate",
 "medical-council-certification": "medical-council-certification",
 "notary-public-foreigners": "notary-public-foreigners",
 "mfa-legalization-foreigners": "mfa-legalization-foreigners",
 "marriage-abroad-thai": "marriage-abroad-thai",
 "naati-online-worldwide": "naati-online-worldwide",
 "government-document-translation": "government-document-translation",
 "government-document-certification": "government-document-certification",
 "embassy-legalization-by-country": "embassy-legalization-by-country"
};

/** Slug → ServiceId, mirrors resolveServiceId() without loading the catalog. */
export function resolveServiceIdLight(slug: string): ServiceId | undefined {
  return ALIASES[slug] as ServiceId | undefined;
}
